import React, { useEffect, useState } from "react";
import MenuApp from '../../../components/Menu';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import informationService from '../../../services/system';
import AuthService from "../../../services/security/auth.service";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import BusinessCenterOutlined from '@mui/icons-material/BusinessCenterOutlined';
import WorkOutline from '@mui/icons-material/WorkOutline';
import { ArrowUpward, ArrowDownward, ArrowRight } from "@mui/icons-material";
import LockOpen from '@mui/icons-material/LockOpen';
import LockOutline from '@mui/icons-material/Lock';
import WalletOutlined from '@mui/icons-material/WalletOutlined';
import LocalAtmOutlined from '@mui/icons-material/LocalAtmOutlined';
import Sensors from '@mui/icons-material/Sensors';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Doughnut from '../../../components/Doughnut';
import { Card, CardContent, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import constantsDesign from '../../../utils/constants';
import DateComponent from '../../../components/Date';
import TokenService from "../../../services/security/token.service";
import FooterOperaciones from "../../../components/Footer";
import fix from "../../../services/fix"
import { BlobProvider } from "@react-pdf/renderer";
import VistaPdfExport from "../../../components/Pdf";
import RefreshIcon from '@mui/icons-material/Refresh';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const backgroundColor = [
    "#1E3A8A", // Azul oscuro
    "#065F46", // Verde oscuro
    "#0D9488", // Turquesa oscuro
    "#F97316", // Naranja vibrante
    "#2563EB", // Azul vibrante
    "#047857", // Verde esmeralda
    "#14B8A6", // Turquesa medio
    "#FB923C", // Naranja medio
    "#3B82F6", // Azul claro
    "#059669", // Verde medio
    "#2DD4BF", // Turquesa claro
    "#FCD34D", // Naranja ámbar
    "#60A5FA", // Azul suave
    "#34D399", // Verde claro
    "#5EEAD4", // Turquesa suave
    "#FEF3C7", // Naranja muy claro
    "#93C5FD", // Azul muy claro
    "#6EE7B7", // Verde menta
    "#99F6E4"  // Turquesa muy claro
]

const Position = () => {
    const user = TokenService.getUser();
    const [entityBalance, setEntityBalance] = useState([]);
    const [entityBalanceUSD, setEntityBalanceUSD] = useState([]);
    const [entityHolding, setEntityHolding] = useState([]);
    const [entityHoldingUSD, setEntityHoldingUSD] = useState([]);
    const [subtotalesCards, setSubtotalesCards] = useState([]);
    const [subtotalesCardsUSD, setSubtotalesCardsUSD] = useState([]);
    const [loadSubtotalesCards, setLoadSubtotalesCards] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});
    const [expandedItemsUSD, setExpandedItemsUSD] = useState({});
    const [totalSubTotal, setSubTotal] = useState({});
    const [totalSubTotalUSD, setSubTotalUSD] = useState({});
    const [totalPortArs, setTotalPortArs] = useState(0);
    const [totalPortUSD, setTotalPortUSD] = useState(0);
    const [portafolioDisponible, setPortafolioDisponible] = useState({});
    const [portafolioGarantia, setPortafolioGarantia] = useState({});
    const [portafolioTotal, setPortafolioTotal] = useState({});
    const [portafolioDisponibleUSD, setPortafolioDisponibleUSD] = useState({});
    const [portafolioGarantiaUSD, setPortafolioGarantiaUSD] = useState({});
    const [portafolioTotalUSD, setPortafolioTotalUSD] = useState({});
    const [portafolioALiquidar, setPortafolioALiquidar] = useState({});
    const [portafolioALiquidarUSD, setPortafolioALiquidarUSD] = useState({});
    const [tipoCambio, setTipoCambio] = useState('');
    const [tipoCambioCcl, setTipoCambioCcl] = useState('');
    const [homeTrade, setHomeTrade] = useState('ars');
    const [filterDate, setFilterDate] = useState(null);
    const [filterComitente, setFilterComitente] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [optionsComitentes, setOptionsComitentes] = useState([]);
    const [optionsComitentesOriginales, setOptionsComitentesOriginales] = useState([]);
    const [filterManager, setFilterManager] = useState(null);
    const [inputValueManager, setInputValueManager] = useState('');
    const [optionsManager, setOptionsManager] = useState([]);
    const [viewComitente, setViewComitente] = useState(false);
    const [viewManager, setViewManager] = useState(false);
    const [prices, setPrices] = useState([]);

    useEffect(() => {

        const init = async () => {

            document.title = `Posición - wBroker`;
            setLoadSubtotalesCards(false);
            searchSourceField();
            let dateNow = formatDate(new Date());
            setFilterDate(dateNow);

            loadInfo(dateNow, filterComitente, filterManager);

            if (user.data.managerId && user.data.tradeAccountId) {
                setViewComitente(true);
                setViewManager(false);
            } else {
                if (user.data.managerId && !user.data.tradeAccountId) {
                    setViewComitente(true);
                    setViewManager(true);
                } else {
                    if (!user.data.managerId && !user.data.tradeAccountId) {
                        setViewComitente(true);
                        setViewManager(true);
                    }
                }
            }
        }
        init();
        // eslint-disable-next-line
    }, []);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const filterByTradeAccountIdManagerId = (tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];

        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        } else {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: null
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : user.data.tradeAccountId
            })
        } else {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : null
            })
        }

        if (user.data.managerId) {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : user.data.managerId
            })
        } else {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : null
            })
        }


        return whereFieldParam;
    }

    const filterByTradeAccountIdManagerIdFindSourceField = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
        return whereFieldParam;
    }

    const searchSourceField = () => {
        let whereFilters = filterByTradeAccountIdManagerIdFindSourceField();

        const arrayTables = [{
            table: `${user.data.instance}.tradeAccount`,
            doc: [],
            selectFilters: ['managerId'],
            whereFilters: whereFilters
        }, {
            table: `${user.data.instance}.manager`,
            doc: [],
            selectFilters: [],
            whereFilters: whereFilters
        }]

        informationService.findSourceField(arrayTables).then((response) => {

            let opcComitentes = [];
            let opcManager = [];
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].source === 'tradeAccount' && response.data[t].isInactive === '0') {
                    opcComitentes.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                        managerId: response.data[t].managerId
                    })
                }
                if (response.data[t].source === 'manager' && response.data[t].isInactive === '0') {
                    opcManager.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                    })
                }
            }

            let managerId = 0;
            let existeComitente = false;
            let existeAgenteProductor = false;
            if (user.data.isManager === '1') {
                setFilterManager({
                    id: user.data.managerId,
                    label: user.data.manager,
                    isInactive: 0,
                });
                managerId = user.data.managerId;
                existeComitente = true;
            }
            if (user.data.tradeAccountId && user.data.managerId) {
                setFilterComitente({
                    id: user.data.tradeAccountId,
                    label: user.data.tradeAccount,
                    isInactive: 0,
                })
                existeAgenteProductor = true;
            }
            if (existeAgenteProductor === true || existeComitente === true) {
                pricesVivo();
            }
            if (managerId > 0) {
                let arrayOptCom = [];
                for (let g = 0; g < opcComitentes.length; g++) {
                    if (Number(opcComitentes[g].managerId) === Number(managerId)) {
                        arrayOptCom.push(opcComitentes[g]);
                    }
                }
                setOptionsComitentes(arrayOptCom);
            } else {
                setOptionsComitentes(opcComitentes);
            }
            setOptionsComitentesOriginales(opcComitentes);
            setOptionsManager(opcManager);

            setLoadSubtotalesCards(true);

        })
    }


    /*
                 * ============================================================
                 * HELPERS
                 * ============================================================
                 */

    const formatNumber = (value) => {

        const number = Number(value || 0);

        return number
            .toFixed(2)
            .toString()
            .replace(/\./g, ',')
            .replace(
                /^(-?\d+),(\d{2})$/,
                (_, integer, decimals) =>
                    `${Number(integer).toLocaleString('es-AR')},${decimals}`
            );
    };


    const loadInfo = (value, tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();

        let date = value.split('-');

        let dueDateFlag = new Date(
            date[0],
            Number(date[1]) - 1,
            date[2]
        );

        let dueDate = formatDate(dueDateFlag);

        let where = filterByTradeAccountIdManagerId(
            tradeAccountId,
            managerId
        );

        informationService
            .storeProcedurePosition(
                'positionAsOf',
                user.data.instance,
                dueDate,
                where
            )
            .then((response) => {

                const data = response.data || [];


                /*
                 * ============================================================
                 * BALANCE
                 * ============================================================
                 */

                const balanceData = data.filter(
                    row =>
                        row.rowType === 'BALANCE'
                );


                /*
                 * ============================================================
                 * SUBTOTALES
                 * ============================================================
                 */

                const subtotalData = data.filter(
                    row =>
                        typeof row.rowType === 'string' &&
                        row.rowType.startsWith('SUBTOTAL_')
                );


                const subtotalACData = subtotalData.filter(
                    row =>
                        row.rowType === 'SUBTOTAL_AC'
                );


                const subtotalCCData = subtotalData.filter(
                    row =>
                        row.rowType === 'SUBTOTAL_CC'
                );


                /*
                 * ============================================================
                 * HOLDINGS
                 *
                 * IMPORTANTE:
                 *
                 * Todo lo que no sea BALANCE ni SUBTOTAL_* es una posición.
                 *
                 * Esto permite:
                 *
                 * HOLDING
                 * OPCION
                 * BONO
                 * CEDEAR
                 * FCI
                 * etc.
                 *
                 * ============================================================
                 */

                const holdingData = data.filter(
                    row =>
                        row.rowType &&
                        row.rowType !== 'BALANCE' &&
                        !row.rowType.startsWith('SUBTOTAL_')
                );


                /*
                 * ============================================================
                 * TIPO DE CAMBIO
                 * ============================================================
                 */

                const firstRow = data.find(
                    row =>
                        row.fxRateUsdMep !== undefined ||
                        row.fxRateUsdCcl !== undefined
                );


                if (firstRow) {

                    setTipoCambio(
                        formatNumber(
                            firstRow.fxRateUsdMep
                        )
                    );

                    setTipoCambioCcl(
                        formatNumber(
                            firstRow.fxRateUsdCcl
                        )
                    );

                }


                /*
                 * ============================================================
                 * BALANCE POR MONEDA
                 * ============================================================
                 */

                const balanceByCurrency = {};


                balanceData.forEach(row => {

                    const currency =
                        `${row.item || ''}`.trim();

                    const status =
                        `${row.status}`;

                    if (!balanceByCurrency[currency]) {

                        balanceByCurrency[currency] = {

                            name: currency,

                            data: {}

                        };

                    }


                    if (
                        !balanceByCurrency[currency]
                            .data[status]
                    ) {

                        balanceByCurrency[currency]
                            .data[status] = [];

                    }


                    balanceByCurrency[currency]
                        .data[status]
                        .push(row);


                });


                /*
                 * ============================================================
                 * BALANCE ARS
                 * ============================================================
                 */

                const responseBalanceView = [];


                /*
                 * ============================================================
                 * BALANCE USD
                 * ============================================================
                 */

                const responseBalanceViewUSD = [];

                Object.values(
                    balanceByCurrency
                ).forEach(currencyGroup => {

                    const dataCurrency =
                        Object.values(
                            currencyGroup.data
                        ).flat();

                    // Mostrar la moneda si tiene cualquier movimiento de BALANCE.
                    // Puede existir solamente A Liquidar, sin una fila Disponible.
                    if (dataCurrency.length > 0) {
                        /*
                         * ========================================================
                         * VISTA NORMAL
                         * ========================================================
                         */

                        const normalGroup = {

                            name:
                                currencyGroup.name,

                            data:
                                [...dataCurrency]

                        };


                        if (
                            dataCurrency.length > 1
                        ) {

                            let amount = 0;
                            let fieldId = null;


                            switch (
                            currencyGroup.name
                            ) {

                                case 'PESOS':

                                    fieldId =
                                        'amountFx';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountFx || 0
                                                );

                                        }
                                    );

                                    break;


                                case 'USD MEP':

                                    fieldId =
                                        'amountFxMep';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountFxMep || 0
                                                );

                                        }
                                    );

                                    break;


                                case 'USD CABLE':

                                    fieldId =
                                        'amountFxCcl';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountFxCcl || 0
                                                );

                                        }
                                    );

                                    break;


                                default:

                                    break;

                            }


                            normalGroup.status = [

                                {
                                    status: 'Total',

                                    [fieldId]:
                                        amount

                                },

                                ...dataCurrency

                            ];

                        } else {

                            normalGroup.status =
                                dataCurrency;

                        }


                        responseBalanceView.push(
                            normalGroup
                        );


                        /*
                         * ========================================================
                         * VISTA USD
                         * ========================================================
                         */

                        const usdGroup = {

                            name:
                                currencyGroup.name,

                            data:
                                [...dataCurrency]

                        };


                        if (
                            dataCurrency.length > 1
                        ) {

                            let amount = 0;
                            let fieldId = null;


                            switch (
                            currencyGroup.name
                            ) {

                                case 'PESOS':

                                    fieldId =
                                        'amountMepFx';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountMepFx || 0
                                                );

                                        }
                                    );

                                    break;


                                case 'USD MEP':

                                    fieldId =
                                        'amountMep';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountMep || 0
                                                );

                                        }
                                    );

                                    break;


                                case 'USD CABLE':

                                    fieldId =
                                        'amountCclFx';

                                    dataCurrency.forEach(
                                        row => {

                                            amount +=
                                                Number(
                                                    row.amountCclFx || 0
                                                );

                                        }
                                    );

                                    break;


                                default:

                                    break;

                            }


                            usdGroup.status = [

                                {
                                    status: 'Total',

                                    [fieldId]:
                                        amount

                                },

                                ...dataCurrency

                            ];

                        } else {

                            usdGroup.status =
                                dataCurrency;

                        }


                        responseBalanceViewUSD.push(
                            usdGroup
                        );
                    }
                });


                /*
                 * ============================================================
                 * SET BALANCE
                 * ============================================================
                 */

                setEntityBalance(
                    responseBalanceView
                );


                setEntityBalanceUSD(
                    responseBalanceViewUSD
                );


                /*
                 * ============================================================
                 * SUBTOTAL CUENTA CORRIENTE
                 * ============================================================
                 */

                const subtotalCC =
                    subtotalCCData[0];


                if (subtotalCC) {

                    const totalPesos =
                        Number(
                            subtotalCC.valueFx || 0
                        );


                    const totalUsd =
                        Number(
                            subtotalCC.valueUsd || 0
                        );


                    const weightPercFx =
                        Number(
                            subtotalCC.weightPercFx || 0
                        );


                    const weightPercUsd =
                        Number(
                            subtotalCC.weightPercUsd || 0
                        );


                    setSubTotal({

                        text:
                            formatNumber(
                                totalPesos
                            ),

                        number:
                            totalPesos

                    });


                    setSubTotalUSD({

                        text:
                            formatNumber(
                                totalUsd
                            ),

                        number:
                            totalUsd

                    });


                    setTotalPortArs({

                        text:
                            formatNumber(
                                weightPercFx
                            ),

                        number:
                            weightPercFx

                    });


                    setTotalPortUSD({

                        text:
                            formatNumber(
                                weightPercUsd
                            ),

                        number:
                            weightPercUsd

                    });

                } else {

                    setSubTotal({

                        text:
                            formatNumber(0),

                        number:
                            0

                    });


                    setSubTotalUSD({

                        text:
                            formatNumber(0),

                        number:
                            0

                    });


                    setTotalPortArs({

                        text:
                            formatNumber(0),

                        number:
                            0

                    });


                    setTotalPortUSD({

                        text:
                            formatNumber(0),

                        number:
                            0

                    });

                }


                /*
                 * ============================================================
                 * HOLDINGS
                 *
                 * !!! CAMBIO IMPORTANTE !!!
                 *
                 * Antes:
                 *
                 *     const itemId = `${row.itemId}`;
                 *
                 * Eso hacía que:
                 *
                 *     ACCION itemId 30038
                 *     OPCION itemId 30038
                 *
                 * quedaran dentro del mismo grupo.
                 *
                 * Ahora agrupamos por:
                 *
                 *     itemId + subtotal
                 *
                 * Por lo tanto:
                 *
                 *     30038_ACCION
                 *     30038_OPCION
                 *
                 * son dos grupos distintos.
                 *
                 * ============================================================
                 */

                const holdingByItem = {};


                holdingData.forEach(row => {

                    const originalItemId =
                        `${row.itemId}`;


                    const subtotal =
                        `${row.subtotal || ''}`;


                    /*
                     * --------------------------------------------------------
                     * CLAVE REAL DE AGRUPACIÓN
                     * --------------------------------------------------------
                     *
                     * itemId solo NO alcanza porque la acción y sus opciones
                     * pueden compartir el mismo itemId.
                     *
                     * Ejemplo del SP:
                     *
                     * ACCION -> itemId 30038
                     * OPCION -> itemId 30038
                     *
                     * Pero:
                     *
                     * ACCION -> subtotal ACCION
                     * OPCION -> subtotal OPCION
                     *
                     * --------------------------------------------------------
                     */

                    const groupKey =
                        `${originalItemId}__${subtotal}`;


                    if (
                        !holdingByItem[groupKey]
                    ) {

                        holdingByItem[groupKey] = {

                            /*
                             * Usamos la clave compuesta para que
                             * expandedItems también pueda manejar
                             * ACCION y OPCION independientemente.
                             */

                            itemId:
                                groupKey,


                            /*
                             * Conservamos el itemId original
                             * por si necesitamos identificarlo.
                             */

                            originalItemId:
                                originalItemId,


                            item:
                                `${row.item || ''}`,

                            symbol:
                                `${row.symbol || ''}`,

                            isin:
                                `${row.isin || ''}`,

                            assetClass:
                                `${row.assetClass || ''}`,

                            assetClassId:
                                `${row.assetClassId || ''}`,

                            subtotal:
                                subtotal,


                            /*
                             * Valores provenientes de SUBTOTAL_AC.
                             */

                            weightPercFx:
                                0,

                            weightPercUsd:
                                0,


                            status:
                                []

                        };

                    }


                    /*
                     * Agregamos el detalle al grupo correspondiente.
                     *
                     * ACCION queda en ACCION.
                     * OPCION queda en OPCION.
                     */

                    holdingByItem[groupKey]
                        .status
                        .push(row);

                });


                /*
                 * ============================================================
                 * HOLDINGS ARS
                 *
                 * Object.values conserva el orden de inserción.
                 *
                 * Como el SP devuelve:
                 *
                 * ACCION
                 * SUBTOTAL ACCION
                 * OPCION
                 * OPCION
                 * OPCION
                 * SUBTOTAL OPCION
                 *
                 * los grupos quedan:
                 *
                 * ACCION
                 * OPCION
                 *
                 * y NO se mezclan.
                 * ============================================================
                 */

                const responseEntityHoldingView =
                    Object.values(
                        holdingByItem
                    );


                /*
                 * ============================================================
                 * ASIGNAR PESOS DE SUBTOTAL_AC
                 * ============================================================
                 */

                responseEntityHoldingView.forEach(
                    item => {

                        const subtotalRow =
                            subtotalACData.find(
                                row =>
                                    `${row.subtotal}` ===
                                    `${item.subtotal}`
                            );


                        if (subtotalRow) {

                            item.weightPercFx =
                                Number(
                                    subtotalRow.weightPercFx || 0
                                );


                            item.weightPercUsd =
                                Number(
                                    subtotalRow.weightPercUsd || 0
                                );

                        }

                    }
                );


                /*
                 * ============================================================
                 * HOLDINGS USD
                 * ============================================================
                 */

                const responseEntityHoldingViewUSD =
                    Object.values(
                        holdingByItem
                    ).map(item => ({

                        ...item,

                        status:
                            [
                                ...item.status
                            ]

                    }));


                /*
                 * ============================================================
                 * SUBTOTALES PARA CARDS
                 *
                 * Importante:
                 *
                 * Acá usamos TODOS los SUBTOTAL_AC del SP.
                 *
                 * Por lo tanto tendremos:
                 *
                 * ACCION
                 * OPCION
                 *
                 * ============================================================
                 */

                const subtotales =
                    subtotalACData.map(
                        row => ({

                            subtotal:
                                row.subtotal,

                            cantidad:
                                Number(
                                    row.qty || 0
                                ),

                            importe:
                                Number(
                                    row.valueFx || 0
                                ),

                            cantidadFinal:
                                formatNumber(
                                    row.qty
                                ),

                            importeFinal:
                                formatNumber(
                                    row.valueFx
                                )

                        })
                    );


                const subtotalesUSD =
                    subtotalACData.map(
                        row => ({

                            subtotal:
                                row.subtotal,

                            cantidad:
                                Number(
                                    row.qty || 0
                                ),

                            importe:
                                Number(
                                    row.valueUsd || 0
                                ),

                            cantidadFinal:
                                formatNumber(
                                    row.qty
                                ),

                            importeFinal:
                                formatNumber(
                                    row.valueUsd
                                )

                        })
                    );


                setSubtotalesCards(
                    subtotales
                );


                setSubtotalesCardsUSD(
                    subtotalesUSD
                );


                setLoadSubtotalesCards(
                    true
                );


                /*
                 * ============================================================
                 * PORTAFOLIO ARS
                 *
                 * Ahora también toma OPCION porque holdingData
                 * contiene HOLDING + OPCION + demás posiciones.
                 * ============================================================
                 */

                let totalDisponible = 0;
                let totalGarantia = 0;
                let totalALiquidar = 0;

                // ============================================================
                // TENENCIA
                //
                // Disponible y A Liquidar salen EXCLUSIVAMENTE de Tenencia.
                // Garantía también se acumula aquí.
                // ============================================================
                holdingData.forEach(row => {
                    const amountFx = Number(row.amountFx || 0);

                    if (row.status === 'Disponible') {
                        totalDisponible += amountFx;
                    }

                    if (row.status === 'Garantía') {
                        totalGarantia += amountFx;
                    }

                    if (row.status === 'A Liquidar') {
                        totalALiquidar += amountFx;
                    }
                });

                // ============================================================
                // CUENTA CORRIENTE
                //
                // La Cuenta Corriente se resume por PESOS / USD MEP /
                // USD CABLE, pero SIN Garantía.
                //
                // Si existe una Garantía en Cuenta Corriente, pasa al único
                // concepto que agrupa Garantías: el total de Garantía.
                //
                // A Liquidar de Cuenta Corriente NO alimenta el A Liquidar
                // superior: queda dentro de Cuenta Corriente.
                // ============================================================
                const cuentaCorriente =
                    responseBalanceView.reduce((total, item) => {
                        return total + item.data.reduce((subtotal, row) => {
                            if (row.status === 'Garantía') {
                                totalGarantia += Number(row.amountFx || 0);
                                return subtotal;
                            }

                            return subtotal + Number(row.amountFx || 0);
                        }, 0);
                    }, 0);

                // ============================================================
                // PORTAFOLIO TOTAL
                //
                // Disponible (Tenencia)
                // + A Liquidar (Tenencia)
                // + Garantía (Tenencia + Cta. Cte.)
                // + Cta. Cte. sin Garantía
                // ============================================================
                const totalPortafolio =
                    totalDisponible +
                    totalALiquidar +
                    totalGarantia +
                    cuentaCorriente;


                setPortafolioDisponible({

                    number:
                        totalDisponible,

                    text:
                        formatNumber(
                            totalDisponible
                        )

                });


                setPortafolioGarantia({

                    number:
                        totalGarantia,

                    text:
                        formatNumber(
                            totalGarantia
                        )

                });


                setPortafolioTotal({

                    number:
                        totalPortafolio,

                    text:
                        formatNumber(
                            totalPortafolio
                        )

                });

                setPortafolioALiquidar({
                    number: totalALiquidar,
                    text: formatNumber(totalALiquidar)
                });


                /*
                 * ============================================================
                 * PORTAFOLIO USD
                 * ============================================================
                 */

                let totalDisponibleUSD = 0;

                let totalGarantiaUSD = 0;

                let totalALiquidarUSD = 0;

                holdingData.forEach(row => {

                    if (
                        row.status === 'Disponible'
                    ) {

                        totalDisponibleUSD +=
                            Number(
                                row.amountUsd || 0
                            );

                    }


                    if (
                        row.status === 'Garantía'
                    ) {

                        totalGarantiaUSD +=
                            Number(
                                row.amountUsd || 0
                            );

                    }

                    if (row.status === 'A Liquidar') {
                        totalALiquidarUSD += Number(row.amountUsd || 0);
                    }

                });


                // ============================================================
                // CUENTA CORRIENTE USD
                //
                // Resume todos los estados de Cta. Cte. excepto Garantía.
                // La Garantía de Cta. Cte. se agrega al único concepto
                // superior de Garantía. A Liquidar superior sale únicamente
                // de Tenencia.
                // ============================================================
                const cuentaCorrienteUSD =
                    responseBalanceViewUSD.reduce((total, item) => {
                        return total + item.data.reduce((subtotal, row) => {
                            if (row.status === 'Garantía') {
                                totalGarantiaUSD += Number(row.amountUsd || 0);
                                return subtotal;
                            }

                            return subtotal + Number(row.amountUsd || 0);
                        }, 0);
                    }, 0);

                const totalPortafolioUSD =
                    totalDisponibleUSD +
                    totalALiquidarUSD +
                    totalGarantiaUSD +
                    cuentaCorrienteUSD;


                setPortafolioDisponibleUSD({

                    number:
                        totalDisponibleUSD,

                    text:
                        formatNumber(
                            totalDisponibleUSD
                        )

                });


                setPortafolioGarantiaUSD({

                    number:
                        totalGarantiaUSD,

                    text:
                        formatNumber(
                            totalGarantiaUSD
                        )

                });


                setPortafolioTotalUSD({

                    number:
                        totalPortafolioUSD,

                    text:
                        formatNumber(
                            totalPortafolioUSD
                        )

                });

                setPortafolioALiquidarUSD({
                    number: totalALiquidarUSD,
                    text: formatNumber(totalALiquidarUSD)
                });


                /*
                 * ============================================================
                 * ENTITY HOLDING
                 * ============================================================
                 */

                setEntityHolding(
                    responseEntityHoldingView
                );


                /*
                 * Como itemId ahora es:
                 *
                 * 30038__ACCION
                 * 30038__OPCION
                 *
                 * cada grupo puede expandirse/contraerse
                 * independientemente.
                 */

                const expandedInitialState = {};


                responseEntityHoldingView.forEach(
                    item => {

                        expandedInitialState[
                            item.itemId
                        ] = true;

                    }
                );


                setExpandedItems(
                    expandedInitialState
                );


                /*
                 * ============================================================
                 * ENTITY HOLDING USD
                 * ============================================================
                 */

                setEntityHoldingUSD(
                    responseEntityHoldingViewUSD
                );


                const expandedInitialStateUSD = {};


                responseEntityHoldingViewUSD.forEach(
                    item => {

                        expandedInitialStateUSD[
                            item.itemId
                        ] = true;

                    }
                );


                setExpandedItemsUSD(
                    expandedInitialStateUSD
                );

            })
            .catch((error) => {

                console.log(error);

            });
    };

    const handleFieldChange = (e) => {
        let value = e.target.value;
        setFilterDate(value);
        setLoadSubtotalesCards(false);

        const today = formatLocalDate(new Date());

        if (value === today) {
            if (prices.length === 0 && (filterComitente || filterManager)) {
                pricesVivo();
            }
        } else {
            setPrices([]);
        }

        loadInfo(value, filterComitente, filterManager);

    }

    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);

        const filtered = optionsComitentes.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {

            setFilterComitente(filtered[0]);
            setLoadSubtotalesCards(false);

            let manag = null;
            for (let g = 0; g < optionsManager.length; g++) {
                if (Number(optionsManager[g].id) === Number(filtered[0].managerId))
                    manag = optionsManager[g];
            }

            setFilterManager(manag);

            loadInfo(filterDate, filtered[0], manag)

            const today = formatLocalDate(new Date());

            if (filterDate === today) {
                if (prices.length === 0) {
                    pricesVivo();
                }
            } else {
                setPrices([]);
            }


        }
    };

    const handleChange = (event, newValue) => {
        setFilterComitente(newValue);
        setLoadSubtotalesCards(false);

        let manag = null;
        if (newValue) {
            for (let g = 0; g < optionsManager.length; g++) {
                if (Number(optionsManager[g].id) === Number(newValue.managerId))
                    manag = optionsManager[g];
            }
        }

        setFilterManager(manag);
        loadInfo(filterDate, newValue, manag);

        const today = formatLocalDate(new Date());

        if (filterDate === today) {
            if (prices.length === 0) {
                pricesVivo();
            }
        } else {
            setPrices([]);
        }
    };

    const handleInputChangeManager = (event, newInputValue) => {
        setInputValueManager(newInputValue);

        const filtered = optionsManager.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterManager(filtered[0]);
            setLoadSubtotalesCards(false);
            let arrayOptCom = [];
            for (let g = 0; g < optionsComitentesOriginales.length; g++) {
                if (optionsComitentesOriginales[g].managerId === filtered[0].id) {
                    arrayOptCom.push(optionsComitentesOriginales[g]);
                }
            }
            setOptionsComitentes(arrayOptCom);
            loadInfo(filterDate, filterComitente, filtered[0])
            const today = formatLocalDate(new Date());

            if (filterDate === today) {
                if (prices.length === 0) {
                    pricesVivo();
                }
            } else {
                setPrices([]);
            }
        }
    };

    const handleChangeManager = (event, newValue) => {
        setFilterManager(newValue);
        setLoadSubtotalesCards(false);
        let arrayOptCom = [];
        if (newValue) {
            for (let g = 0; g < optionsComitentesOriginales.length; g++) {
                if (optionsComitentesOriginales[g].managerId === newValue.id) {
                    arrayOptCom.push(optionsComitentesOriginales[g]);
                }
            }
        }
        /*else {
            arrayOptCom = optionsComitentesOriginales;
        }*/
        setOptionsComitentes(arrayOptCom);
        loadInfo(filterDate, filterComitente, newValue)
        const today = formatLocalDate(new Date());

        if (filterDate === today) {
            if (prices.length === 0) {
                pricesVivo();
            }
        } else {
            setPrices([]);
        }
    };

    const setViewEntityBalance = (item, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let cantidad = 0;
            let fieldId = 'qty';

            amount = Number(item.data[g].valueFx).toFixed(2).toString().replace(/\./g, ',');
            cantidad = Number(item.data[g].qty).toFixed(2).toString().replace(/\./g, ',');

            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }
            valueSplit = cantidad.split(',');
            if (valueSplit.length > 1) {
                cantidad = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            let weightPerc = '0,00';
            if (item.data[g].weightPercFx) {
                weightPerc = Number(item.data[g].weightPercFx).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = weightPerc.split(',');
                if (valueSplit.length > 1) {
                    weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }
            }


            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        {/*<TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>*/}
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.data[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }}></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ fontVariantNumeric: 'tabular-nums', minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        {/*<TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>*/}
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.data[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const setViewEntityBalanceUSD = (item, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let amountMepFx = 0;
            let cantidad = 0;
            let fieldId = 'qty';

            amount = Number(item.data[g].valueUsd).toFixed(2).toString().replace(/\./g, ',');
            amountMepFx = Number(item.data[g].valueFx).toFixed(2).toString().replace(/\./g, ',');


            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            valueSplit = amountMepFx.split(',');
            if (valueSplit.length > 1) {
                amountMepFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            cantidad = Number(item.data[g].qty).toFixed(2).toString().replace(/\./g, ',');
            valueSplit = cantidad.split(',');
            if (valueSplit.length > 1) {
                cantidad = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            let weightPerc = '0,00';
            if (item.data[g].weightPercUsd) {
                weightPerc = Number(item.data[g].weightPercUsd).toFixed(2).toString().replace(/\./g, ',');
                valueSplit = weightPerc.split(',');
                if (valueSplit.length > 1) {
                    weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                } else {
                    weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                }
            }


            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                {/*<span>{item.name === 'PESOS' ? amount : amountMepFx}</span>*/}
                                <span>{amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        {/*<TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>*/}
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.data[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }}></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                {/*<span>{item.name === 'PESOS' ? amount : amountMepFx}</span>*/}
                                <span>{amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        {/*<TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>*/}
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.data[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const toggleItem = (itemId) => {
        setExpandedItems(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const toggleItemUSD = (itemId) => {
        setExpandedItemsUSD(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const amountCtaCte = (item) => {
        let amountFx = 0;
        let flagAmount = 0;

        for (let j = 0; j < item.data.length; j++) {

            // La Cuenta Corriente resume todos los estados excepto
            // Garantía. Las Garantías ya están agrupadas en su propio
            // concepto superior.
            if (item.data[j].status === 'Garantía') {
                continue;
            }

            flagAmount += Number(item.data[j].amountFx || 0);
        }

        amountFx = Number(flagAmount)
            .toFixed(2)
            .toString()
            .replace(/\./g, ',');

        let valueSplit = amountFx.split(',');

        if (valueSplit.length > 1) {
            amountFx =
                `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx =
                `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return {
            number: flagAmount,
            text: amountFx
        };
    };


    const amountCtaCteUSD = (item) => {
        let amountFx = 0;
        let flagAmount = 0;

        for (let j = 0; j < item.data.length; j++) {

            // La Cuenta Corriente resume todos los estados excepto
            // Garantía. Las Garantías ya están agrupadas en su propio
            // concepto superior.
            if (item.data[j].status === 'Garantía') {
                continue;
            }

            flagAmount += Number(item.data[j].amountUsd || 0);
        }

        amountFx = Number(flagAmount)
            .toFixed(2)
            .toString()
            .replace(/\./g, ',');

        let valueSplit = amountFx.split(',');

        if (valueSplit.length > 1) {
            amountFx =
                `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx =
                `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return {
            number: flagAmount,
            text: amountFx
        };
    };


    const buscarPrecioEnvio = (symbol) => {
        let candidatos = [];

        if (!prices) {
            return null;
        }

        for (let t = 0; t < prices.length; t++) {

            if (!prices[t] || !prices[t].subTabs) {
                continue;
            }

            for (let d = 0; d < prices[t].subTabs.length; d++) {

                const especies = prices[t].subTabs[d].especies || [];

                for (let e = 0; e < especies.length; e++) {

                    const especie = especies[e];

                    if (!especie || !especie.SecurityID) {
                        continue;
                    }

                    const partes = especie.SecurityID.split("-");

                    if (
                        symbol !== especie.Symbol ||
                        partes.length < 4 ||
                        partes[2] !== "C" ||
                        partes[3] !== "CT"
                    ) {
                        continue;
                    }

                    // MODIFICACION 03092026
                    let validateBlock = false;

                    if (partes[4] === "ARS" && symbol.slice(-1) === "B") {
                        validateBlock = true;
                    }

                    if (validateBlock) {
                        continue;
                    }

                    /*
                     * SecurityID ejemplo:
                     *
                     * AAPL-0002-C-CT-ARS
                     * AAPL-0001-C-CT-ARS
                     *
                     * Tomamos el 0002 / 0001 para determinar prioridad.
                     */
                    const securityNumber = Number(partes[1]);

                    let precioCierre = null;
                    let precioFlag = null;

                    const entries = especie.NoMDEntries || [];

                    for (let e1 = 0; e1 < entries.length; e1++) {

                        const entry = entries[e1];

                        if (!entry) {
                            continue;
                        }

                        // Precio de cierre
                        if (
                            entry.MDEntryType === "5" &&
                            entry.MDEntryPx !== null &&
                            entry.MDEntryPx !== undefined &&
                            Number(entry.MDEntryPx) > 0
                        ) {
                            precioCierre = Number(entry.MDEntryPx);
                        }

                        // Precio en vivo para settlement type 2
                        if (
                            entry.MDEntryType === "2" &&
                            entry.MDEntryPx !== null &&
                            entry.MDEntryPx !== undefined &&
                            Number(entry.MDEntryPx) > 0
                        ) {
                            precioFlag = Number(entry.MDEntryPx);
                        }
                    }

                    candidatos.push({
                        securityNumber,
                        precioCierre,
                        precio: precioFlag,
                        settlType: partes[1],
                        securityId: especie.SecurityID
                    });
                }
            }
        }

        /*
         * Mayor SecurityID primero:
         *
         * 0002
         * 0001
         */
        candidatos.sort((a, b) => b.securityNumber - a.securityNumber);


        /*
         * Primero buscamos precio de cierre.
         *
         * Si 0002 tiene cierre, usamos 0002.
         * Si 0002 no tiene cierre, seguimos con 0001.
         */
        for (let i = 0; i < candidatos.length; i++) {

            const candidato = candidatos[i];

            if (
                candidato.precioCierre !== null &&
                candidato.precioCierre !== undefined &&
                Number(candidato.precioCierre) > 0
            ) {

                return {
                    precio: candidato.precio,
                    precioCierre: candidato.precioCierre,
                    settlType: candidato.settlType,
                    securityId: candidato.securityId
                };
            }
        }

        /*
         * Si ninguno tiene precio de cierre,
         * buscamos precio en vivo respetando el orden
         * 0002 -> 0001.
         */
        for (let i = 0; i < candidatos.length; i++) {

            const candidato = candidatos[i];

            if (
                candidato.precio !== null &&
                candidato.precio !== undefined &&
                Number(candidato.precio) > 0
            ) {

                return {
                    precio: candidato.precio,
                    precioCierre: null,
                    settlType: candidato.settlType,
                    securityId: candidato.securityId
                };
            }
        }

        /*
         * FIX no tiene precio utilizable.
         * El código que consume esta función podrá
         * continuar con el precio del SP.
         */
        return null;
    };


    const setViewEntitHolding = (entityHolding, mode = "ui") => {
        const isPdf = mode === "pdf";

        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;


        let response = [];
        let subtotalAmount = 0;
        let subtotalCostFx = 0;
        let resultadoTotal = 0;

        let subtotalWeightPercFx = 0;

        let subtotal = null;
        let rowIndex = 0;

        entityHolding.forEach((item, index) => {
            const isItemExpanded = expandedItems[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;


            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    //precios en vivo
                    let isPrecioEnVivo = false;
                    let isPrecioEnVivoCierre = false;
                    let isFactor = '';
                    const today = formatLocalDate(new Date());

                    if (prices.length > 0 && today === filterDate) {
                        console.log('fxSecurity-> ' + item.status[g].fxSecurity)
                        const precioEnVivo = buscarPrecioEnvio(item.status[g].fxSecurity);
                        console.log('precioEnVivo-> ' + JSON.stringify(precioEnVivo))
                        if (item.status[g].factor === null || item.status[g].factor === undefined) {
                            item.status[g].factor = 0;
                            item.status[g].flagIsfactor = true;
                        }
                        if (item.status[g].flagIsfactor === true) {
                            isFactor = '*';
                        }

                        if (precioEnVivo !== null) {
                            if (precioEnVivo.precio !== null && precioEnVivo.precio !== undefined && Number(precioEnVivo.precio) !== 0) {

                                let precioFlag = Number(precioEnVivo.precioCierre ? precioEnVivo.precioCierre : precioEnVivo.precio);

                                item.status[g].fxPrice = Number(precioFlag);
                                console.log('fxPrice-> ' + JSON.stringify(item.status[g].fxPrice))
                                console.log('item.status[g].factor-> ' + JSON.stringify(item.status[g].factor))
                                if (Number(item.status[g].factor) !== 0) {
                                    item.status[g].amountFx = (Number(precioFlag) * Number(item.status[g].qty)) / Number(item.status[g].factor);
                                }
                                console.log('item.status[g].amountFx-> ' + JSON.stringify(item.status[g].amountFx))
                                if (!item.status[g].costFx)
                                    item.status[g].costFx = 0;
                                console.log('item.status[g].costFx-> ' + JSON.stringify(item.status[g].costFx))
                                item.status[g].profitFx = Number(item.status[g].amountFx) - Number(item.status[g].costFx);

                                console.log('item.status[g].profitFx-> ' + JSON.stringify(item.status[g].profitFx))
                                console.log('item.status[g].costPriceFx-> ' + JSON.stringify(item.status[g].costPriceFx))
                                console.log('item.status[g].costFx-> ' + JSON.stringify(item.status[g].costFx))
                                //item.status[g].profitPerc = (Number(item.status[g].profitFx) / Number(item.status[g].amountFx)).toFixed(2);
                                //item.status[g].profitPerc = (((Number(item.status[g].profitFx) - Number(item.status[g].costPriceFx)) / Number(item.status[g].costFx)) * 100).toFixed(2);
                                item.status[g].profitPerc = (((Number(item.status[g].amountFx) / Number(item.status[g].costFx)) - 1) * 100).toFixed(2);
                                if (precioEnVivo.precioCierre === null)
                                    isPrecioEnVivo = true;
                                else
                                    isPrecioEnVivoCierre = true;
                            }
                        }
                    }
                    //precios en vivo


                    const isFirstRow = g === 0;
                    let amountFx = Number(
                        item.status[g].amountFx ?? item.status[g].valueFx ?? 0
                    )
                        .toFixed(2)
                        .toString()
                        .replace(/\./g, ',');
                    let valueSplit = amountFx.split(',');
                    if (valueSplit.length > 1) {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPrice = '0,00';
                    if (item.status[g].fxPrice) {
                        fxPrice = Number(item.status[g].fxPrice).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPrice.split(',');
                        if (valueSplit.length > 1) {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costFx = '0,00';
                    if (item.status[g].costFx) {
                        costFx = Number(item.status[g].costFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costFx.split(',');
                        if (valueSplit.length > 1) {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costPriceFx = '0,00';
                    if (item.status[g].costPriceFx) {
                        costPriceFx = Number(item.status[g].costPriceFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costPriceFx.split(',');
                        if (valueSplit.length > 1) {
                            costPriceFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costPriceFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let weightPerc = '0,00';
                    if (item.status[g].weightPercFx) {
                        weightPerc = Number(item.status[g].weightPercFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = weightPerc.split(',');
                        if (valueSplit.length > 1) {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let profitFx = '0,00';
                    if (item.status[g].profitFx) {
                        profitFx = Number(item.status[g].profitFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitFx.split(',');
                        if (valueSplit.length > 1) {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.status[g].profitPerc === null || item.status[g].profitPerc === undefined) {
                        item.status[g].profitPerc = 0;
                    }


                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalWeightPercFxFlag =
                            Number(subtotalWeightPercFx)
                                .toFixed(2)
                                .replace(/\./g, ',');

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>

                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostFx) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostFxFlag}</TableCell>

                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>

                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                            <TableCell
                                style={{
                                    fontVariantNumeric: 'tabular-nums',
                                    letterSpacing: "0.01rem",
                                    color: Number(subtotalWeightPercFx) < 0
                                        ? "red"
                                        : "black",
                                    fontSize,
                                    padding: cellPadding,
                                    lineHeight: isPdf ? 1.2 : "normal"
                                }}
                                align="right"
                            >
                                {subtotalWeightPercFxFlag}%
                            </TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                        subtotalCostFx = Number(item.status[g].costFx ? item.status[g].costFx : 0);
                        resultadoTotal = Number(item.status[g].profitFx ? item.status[g].profitFx : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        const existeTotal = item.status.some(
                            x => x.status === 'Total'
                        );

                        if (existeTotal) {

                            // Si existe Total, SOLO acumulamos la fila Total
                            if (item.status[g].status === 'Total') {
                                subtotalAmount =
                                    Number(subtotalAmount) +
                                    Number(item.status[g].amountFx ?? 0);

                                subtotalCostFx =
                                    Number(subtotalCostFx) +
                                    Number(item.status[g].costFx ?? 0);

                                resultadoTotal =
                                    Number(resultadoTotal) +
                                    Number(item.status[g].profitFx ?? 0);
                            }

                        } else {

                            // Si no existe Total, acumulamos las filas normales
                            if (item.status[g].status !== 'Total') {
                                subtotalAmount =
                                    Number(subtotalAmount) +
                                    Number(item.status[g].amountFx ?? 0);

                                subtotalCostFx =
                                    Number(subtotalCostFx) +
                                    Number(item.status[g].costFx ?? 0);

                                resultadoTotal =
                                    Number(resultadoTotal) +
                                    Number(item.status[g].profitFx ?? 0);
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItem(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {item.status[g]?.symbol || (isFirstRow ? item.symbol : "")}
                        </TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>{isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>{item.status[g].status}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{qty}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costPriceFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costPriceFx}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costFx}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: (isPrecioEnVivo === true ? "#323B98" : isPrecioEnVivoCierre === true ? "#060e6d" : (Number(item.status[g].fxPrice) < 0 ? "red" : "black")), fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{fxPrice} {isFactor}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].amountFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{amountFx}</TableCell>

                        <TableCell
                            style={{
                                letterSpacing: "0.01rem",
                                fontSize,
                                padding: cellPadding
                            }}
                            align="right"
                        >
                            <>
                                {Number(item.status[g].profitPerc ?? 0)
                                    .toFixed(2)
                                    .replace('.', ',')}%

                                {Number(item.status[g].profitPerc ?? 0) > 0 ? (
                                    <ArrowUpward
                                        style={{
                                            color: "green",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                ) : Number(item.status[g].profitPerc ?? 0) < 0 ? (
                                    <ArrowDownward
                                        style={{
                                            color: "red",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                ) : (
                                    <ArrowRight
                                        style={{
                                            color: "gray",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                )}
                            </>
                        </TableCell>


                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].profitFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{profitFx}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>

                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    subtotalWeightPercFx =
                        Number(portafolioTotal?.number || 0) !== 0
                            ? (
                                Number(subtotalAmount || 0) /
                                Number(portafolioTotal.number)
                            ) * 100
                            : 0;
                    let validateFinalLine = false;
                    if (index === entityHolding.length - 1 && isItemExpanded) {
                        if (g === item.status.length - 1) {
                            validateFinalLine = true;
                        }
                    }
                    if (index === entityHolding.length - 1 && !isItemExpanded) {
                        validateFinalLine = true;
                    }
                    if (validateFinalLine) {
                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalWeightPercFxFlag =
                            Number(subtotalWeightPercFx)
                                .toFixed(2)
                                .replace(/\./g, ',');

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostFxFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                            <TableCell
                                style={{
                                    fontVariantNumeric: 'tabular-nums',
                                    letterSpacing: "0.01rem",
                                    color: Number(subtotalWeightPercFx) < 0
                                        ? "red"
                                        : "black",
                                    fontSize,
                                    padding: cellPadding,
                                    lineHeight: isPdf ? 1.2 : "normal"
                                }}
                                align="right"
                            >
                                {subtotalWeightPercFxFlag}%
                            </TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })


        return response;
    };

    const setViewEntitHoldingMEP = (entityHoldingUSD, mode = "ui") => {
        const isPdf = mode === "pdf";

        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let response = [];
        let subtotalAmount = 0;
        let subtotal = null;
        let resultadoTotal = 0;
        let subtotalCostMep = 0;

        let subtotalWeightPercUsd = 0;

        let rowIndex = 0;

        entityHoldingUSD.forEach((item, index) => {
            const isItemExpanded = expandedItemsUSD[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;

            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    let isPrecioEnVivo = false;
                    let isPrecioEnVivoCierre = false;
                    let isFactor = '';
                    //precios en vivo
                    const today = formatLocalDate(new Date());

                    if (prices.length > 0 && today === filterDate) {

                        const precioEnVivo = buscarPrecioEnvio(item.status[g].fxUsdSecurity);
                        if (item.status[g].factor === null || item.status[g].factor === undefined) {
                            item.status[g].factor = 0;
                            item.status[g].flagIsfactor = true;
                        }
                        if (item.status[g].flagIsfactor === true) {
                            isFactor = '*';
                        }
                        if (precioEnVivo !== null) {
                            if (precioEnVivo.precio !== null && precioEnVivo.precio !== undefined && Number(precioEnVivo.precio) !== 0) {

                                let precioFlag = Number(precioEnVivo.precioCierre ? precioEnVivo.precioCierre : precioEnVivo.precio);

                                item.status[g].fxPriceUsd = Number(precioFlag);
                                if (Number(item.status[g].factor) !== 0) {
                                    item.status[g].amountUsd = (Number(precioFlag) * Number(item.status[g].qty)) / Number(item.status[g].factor);

                                }
                                if (!item.status[g].costUsd)
                                    item.status[g].costUsd = 0;
                                item.status[g].profitUsd = Number(item.status[g].amountUsd) - Number(item.status[g].costUsd);
                                //item.status[g].profitUsdPerc = (Number(item.status[g].profitUsd) / Number(item.status[g].amountUsd)).toFixed(2);
                                //item.status[g].profitUsdPerc = (((Number(item.status[g].profitUsd) - Number(item.status[g].costPriceUsd)) / Number(item.status[g].costUsd)) * 100).toFixed(2);


                                item.status[g].profitUsdPerc = (((Number(item.status[g].amountUsd) / Number(item.status[g].costUsd)) - 1) * 100).toFixed(2);

                                if (precioEnVivo.precioCierre === null)
                                    isPrecioEnVivo = true;
                                else
                                    isPrecioEnVivoCierre = true;

                            }
                        }
                    }
                    //precios en vivo

                    const isFirstRow = g === 0;
                    let amountUsd = Number(
                        item.status[g].amountUsd ?? item.status[g].valueUsd ?? 0
                    )
                        .toFixed(2)
                        .toString()
                        .replace(/\./g, ',');
                    let valueSplit = amountUsd.split(',');
                    if (valueSplit.length > 1) {
                        amountUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPriceUsd = '0,00';
                    if (item.status[g].fxPriceUsd) {
                        fxPriceUsd = Number(item.status[g].fxPriceUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPriceUsd.split(',');
                        if (valueSplit.length > 1) {
                            fxPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty.toString()).toFixed(2).replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costUsd = '0,00';
                    if (item.status[g].costUsd) {
                        costUsd = Number(item.status[g].costUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costUsd.split(',');
                        if (valueSplit.length > 1) {
                            costUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }
                    let costPriceUsd = '0,00';
                    if (item.status[g].costPriceUsd) {
                        costPriceUsd = Number(item.status[g].costPriceUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costPriceUsd.split(',');
                        if (valueSplit.length > 1) {
                            costPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let weightPerc = '0,00';
                    if (item.status[g].weightPercUsd) {
                        weightPerc = Number(item.status[g].weightPercUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = weightPerc.split(',');
                        if (valueSplit.length > 1) {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let profitUsd = '0,00';
                    if (item.status[g].profitUsd) {
                        profitUsd = Number(item.status[g].profitUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitUsd.split(',');
                        if (valueSplit.length > 1) {
                            profitUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.status[g].profitUsdPerc === null || item.status[g].profitUsdPerc === undefined) {
                        item.status[g].profitUsdPerc = 0;
                    }

                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalWeightPercUsdFlag =
                            Number(subtotalWeightPercUsd)
                                .toFixed(2)
                                .replace(/\./g, ',');

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                //backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                            <TableCell
                                style={{
                                    fontVariantNumeric: 'tabular-nums',
                                    letterSpacing: "0.01rem",
                                    color: Number(subtotalWeightPercUsd) < 0
                                        ? "red"
                                        : "black",
                                    fontSize,
                                    padding: cellPadding,
                                    lineHeight: isPdf ? 1.2 : "normal"
                                }}
                                align="right"
                            >
                                {subtotalWeightPercUsdFlag}%
                            </TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountUsd ? item.status[g].amountUsd : 0);
                        subtotalCostMep = Number(item.status[g].costUsd ? item.status[g].costUsd : 0);
                        resultadoTotal = Number(item.status[g].profitUsd ? item.status[g].profitUsd : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        const existeTotal = item.status.some(
                            row => row.status === 'Total'
                        );

                        if (existeTotal) {

                            if (item.status[g].status === 'Total') {

                                subtotalAmount += Number(
                                    item.status[g].amountUsd ?? 0
                                );

                                subtotalCostMep += Number(
                                    item.status[g].costUsd ?? 0
                                );

                                resultadoTotal += Number(
                                    item.status[g].profitUsd ?? 0
                                );
                            }

                        } else {

                            if (item.status[g].status !== 'Total') {

                                subtotalAmount += Number(
                                    item.status[g].amountUsd ?? 0
                                );

                                subtotalCostMep += Number(
                                    item.status[g].costUsd ?? 0
                                );

                                resultadoTotal += Number(
                                    item.status[g].profitUsd ?? 0
                                );
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItemUSD(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {item.status[g]?.symbol || (isFirstRow ? item.symbol : "")}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {item.status[g].status}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{qty}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costPriceUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costPriceUsd}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costUsd}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: (isPrecioEnVivo === true ? "#323B98" : isPrecioEnVivoCierre === true ? "#060e6d" : (Number(item.status[g].fxPriceUsd) < 0 ? "red" : "black")), fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{fxPriceUsd} {isFactor}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].amountUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{amountUsd}</TableCell>


                        <TableCell
                            style={{
                                letterSpacing: "0.01rem",
                                fontSize,
                                padding: cellPadding
                            }}
                            align="right"
                        >
                            <>
                                {Number(item.status[g].profitUsdPerc ?? 0)
                                    .toFixed(2)
                                    .replace('.', ',')}%

                                {Number(item.status[g].profitUsdPerc ?? 0) > 0 ? (
                                    <ArrowUpward
                                        style={{
                                            color: "green",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                ) : Number(item.status[g].profitUsdPerc ?? 0) < 0 ? (
                                    <ArrowDownward
                                        style={{
                                            color: "red",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                ) : (
                                    <ArrowRight
                                        style={{
                                            color: "gray",
                                            fontSize: "1rem",
                                            marginLeft: 4
                                        }}
                                    />
                                )}
                            </>
                        </TableCell>

                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].profitUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{profitUsd}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                    </TableRow>
                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    subtotalWeightPercUsd =
                        Number(item.weightPercUsd || 0);

                    let validateFinalLine = false;
                    if (index === entityHoldingUSD.length - 1 && isItemExpanded) {
                        if (g === item.status.length - 1) {
                            validateFinalLine = true;
                        }
                    }
                    if (index === entityHoldingUSD.length - 1 && !isItemExpanded) {
                        validateFinalLine = true;
                    }
                    if (validateFinalLine) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalWeightPercUsdFlag =
                            Number(subtotalWeightPercUsd)
                                .toFixed(2)
                                .replace(/\./g, ',');

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                //backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                            <TableCell
                                style={{
                                    fontVariantNumeric: 'tabular-nums',
                                    letterSpacing: "0.01rem",
                                    color: Number(subtotalWeightPercUsd) < 0
                                        ? "red"
                                        : "black",
                                    fontSize,
                                    padding: cellPadding,
                                    lineHeight: isPdf ? 1.2 : "normal"
                                }}
                                align="right"
                            >
                                {subtotalWeightPercUsdFlag}%
                            </TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })

        return response;
    };

    const totalImporteFinal =
        Number(totalSubTotal?.number || 0) +
        subtotalesCards.reduce(
            (sum, card) => sum + Number(card.importe || 0),
            0
        );

    const totalImporteFinalUSD =
        Number(totalSubTotalUSD?.number || 0) +
        subtotalesCardsUSD.reduce(
            (sum, card) => sum + Number(card.importe || 0),
            0
        );

    const handleChangeHomeTrade = (homeTrade) => {
        setHomeTrade(homeTrade);
    }

    const getRowStyle = (isSubtotal, rowIndex) => {
        let baseColor = "white";

        if (isSubtotal) {
            baseColor = "rgba(0, 0, 0, 0.04)";
        } else {
            baseColor = rowIndex % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.02)";
        }

        return {
            backgroundColor: baseColor,
            "&:hover": {
                backgroundColor: "#e6ffff", // color al pasar con el mouse
            },
        };
    };

    /*const pricesVivo = async () => {

        const securityType = ['CS', 'FUT', 'QS', 'CORP', 'GO', 'CD', 'OPT'];
        let responseFixPrices = [];
        for (let i = 0; i < securityType.length; i++) {
            const responseFixCs = await fix.prices(securityType[i]);
            responseFixPrices.push(responseFixCs.data[0]);
        }
        setPrices(responseFixPrices);

    }*/

    const pricesVivo = () => {
        const securityType = ['CS', 'FUT', 'QS', 'CORP', 'GO', 'CD', 'OPT'];

        setPrices([]);

        securityType.forEach(type => {
            fix.prices(type).then(response => {
                const newPrice = response.data[0];
                setPrices(prev => [...prev, newPrice]);
            }).catch(error => {
                console.error("Error en", type, error);
            });
        });

    };

    useEffect(() => {
        if (!prices.length) return;
        if (!entityHolding.length && !entityHoldingUSD.length) return;

        const today = formatLocalDate(new Date());

        // Solo recalculamos con precios en vivo para la fecha actual
        if (filterDate !== today) return;


        /*
         * ============================================================
         * RECALCULO DINÁMICO PORTAFOLIO ARS
         * ============================================================
         */

        let totalDisponible = 0;
        let totalGarantia = 0;
        let totalALiquidar = 0;

        const subtotalesMap = {};

        entityHolding.forEach(item => {

            const subtotal = item.subtotal || '';

            if (!subtotalesMap[subtotal]) {
                subtotalesMap[subtotal] = 0;
            }

            const existeTotal = item.status.some(
                row => row.status === 'Total'
            );

            let totalGrupo = 0;

            item.status.forEach(row => {

                let amountFx = Number(row.amountFx || 0);

                // precio vivo...

                if (row.status === 'Disponible') {
                    totalDisponible += amountFx;
                }

                if (row.status === 'Garantía') {
                    totalGarantia += amountFx;
                }

                if (row.status === 'A Liquidar') {
                    totalALiquidar += amountFx;
                }

                if (existeTotal) {
                    if (row.status === 'Total') {
                        totalGrupo = amountFx;
                    }
                } else {
                    if (row.status !== 'Total') {
                        totalGrupo += amountFx;
                    }
                }
            });

            subtotalesMap[subtotal] += totalGrupo;
        });

        // ============================================================
        // CUENTA CORRIENTE DINÁMICA
        //
        // Suma todos los estados de Cuenta Corriente EXCEPTO Garantía.
        // Garantía se acumula en su propio concepto superior.
        // A Liquidar de Cta. Cte. queda dentro de Cta. Cte. y NO alimenta
        // el concepto superior A Liquidar, que sale exclusivamente de
        // Tenencia.
        // ============================================================
        const cuentaCorriente =
            entityBalance.reduce((total, item) => {
                return total + item.data.reduce((subtotal, row) => {
                    if (row.status === 'Garantía') {
                        totalGarantia += Number(row.amountFx || 0);
                        return subtotal;
                    }

                    return subtotal + Number(row.amountFx || 0);
                }, 0);
            }, 0);


        // ============================================================
        // PORTAFOLIO TOTAL DINÁMICO ARS
        //
        // Misma fórmula que loadInfo:
        // Disponible
        // + Garantía
        // + Cuenta Corriente Disponible
        // + A Liquidar
        // ============================================================

        const totalPortafolio =
            totalDisponible +
            totalALiquidar +
            totalGarantia +
            cuentaCorriente;

        /*
         * ============================================================
         * ESTADOS SUPERIORES ARS
         * ============================================================
         */

        setPortafolioDisponible({
            number: totalDisponible,
            text: formatNumber(totalDisponible)
        });

        setPortafolioGarantia({
            number: totalGarantia,
            text: formatNumber(totalGarantia)
        });

        setPortafolioTotal({
            number: totalPortafolio,
            text: formatNumber(totalPortafolio)
        });


        setPortafolioALiquidar({
            number: totalALiquidar,
            text: formatNumber(totalALiquidar)
        });

        /*
         * ============================================================
         * CARDS ARS
         * ============================================================
         */

        const cardsARS = Object.entries(subtotalesMap)
            .filter(([subtotal]) => subtotal !== '')
            .map(([subtotal, importe]) => ({
                subtotal,
                importe,
                importeFinal: formatNumber(importe),
                weightPerc:
                    totalPortafolio !== 0
                        ? (importe / totalPortafolio) * 100
                        : 0
            }));


        setSubtotalesCards(cardsARS);


        /*
         * ============================================================
         * %/PORT CUENTA CORRIENTE
         * ============================================================
         */

        const weightCC =
            totalPortafolio !== 0
                ? (cuentaCorriente / totalPortafolio) * 100
                : 0;

        setTotalPortArs({
            number: weightCC,
            text: formatNumber(weightCC)
        });



        /*
         * ============================================================
         * RECALCULO DINÁMICO PORTAFOLIO USD
         * ============================================================
         */

        let totalDisponibleUSD = 0;
        let totalGarantiaUSD = 0;
        let totalALiquidarUSD = 0;

        const subtotalesMapUSD = {};

        entityHoldingUSD.forEach(item => {

            const subtotal = item.subtotal || '';

            if (!subtotalesMapUSD[subtotal]) {
                subtotalesMapUSD[subtotal] = 0;
            }

            const existeTotal = item.status.some(
                row => row.status === 'Total'
            );

            let totalGrupo = 0;

            item.status.forEach(row => {

                let amountUsd = Number(row.amountUsd || 0);

                /*
                 * Precio en vivo
                 */
                const precioEnVivo =
                    buscarPrecioEnvio(row.fxUsdSecurity);

                if (
                    precioEnVivo &&
                    precioEnVivo.precio !== null &&
                    precioEnVivo.precio !== undefined &&
                    Number(precioEnVivo.precio) !== 0
                ) {
                    const precioFlag = Number(
                        precioEnVivo.precioCierre
                            ? precioEnVivo.precioCierre
                            : precioEnVivo.precio
                    );

                    if (Number(row.factor) !== 0) {
                        amountUsd =
                            (precioFlag * Number(row.qty || 0)) /
                            Number(row.factor);
                    }
                }

                /*
                 * Estados superiores
                 */
                if (row.status === 'Disponible') {
                    totalDisponibleUSD += amountUsd;
                }

                if (row.status === 'Garantía') {
                    totalGarantiaUSD += amountUsd;
                }

                if (row.status === 'A Liquidar') {
                    totalALiquidarUSD += amountUsd;
                }

                /*
                 * Subtotal
                 */
                if (existeTotal) {

                    if (row.status === 'Total') {
                        totalGrupo = amountUsd;
                    }

                } else {

                    if (row.status !== 'Total') {
                        totalGrupo += amountUsd;
                    }
                }
            });

            subtotalesMapUSD[subtotal] += totalGrupo;
        });

        // ============================================================
        // CUENTA CORRIENTE DINÁMICA USD
        //
        // Suma todos los estados de Cuenta Corriente EXCEPTO Garantía.
        // Garantía se acumula en su propio concepto superior.
        // A Liquidar de Cta. Cte. queda dentro de Cta. Cte. y NO alimenta
        // el concepto superior A Liquidar, que sale exclusivamente de
        // Tenencia.
        // ============================================================
        const cuentaCorrienteUSD =
            entityBalanceUSD.reduce((total, item) => {
                return total + item.data.reduce((subtotal, row) => {
                    if (row.status === 'Garantía') {
                        totalGarantiaUSD += Number(row.amountUsd || 0);
                        return subtotal;
                    }

                    return subtotal + Number(row.amountUsd || 0);
                }, 0);
            }, 0);


        // ============================================================
        // PORTAFOLIO TOTAL DINÁMICO USD
        //
        // Disponible
        // + Garantía
        // + Cuenta Corriente Disponible
        // + A Liquidar
        // ============================================================

        const totalPortafolioUSD =
            totalDisponibleUSD +
            totalALiquidarUSD +
            totalGarantiaUSD +
            cuentaCorrienteUSD;


        /*
         * ============================================================
         * ESTADOS SUPERIORES USD
         * ============================================================
         */

        setPortafolioDisponibleUSD({
            number: totalDisponibleUSD,
            text: formatNumber(totalDisponibleUSD)
        });

        setPortafolioGarantiaUSD({
            number: totalGarantiaUSD,
            text: formatNumber(totalGarantiaUSD)
        });

        setPortafolioTotalUSD({
            number: totalPortafolioUSD,
            text: formatNumber(totalPortafolioUSD)
        });

        setPortafolioALiquidarUSD({
            number: totalALiquidarUSD,
            text: formatNumber(totalALiquidarUSD)
        });

        /*
         * ============================================================
         * CARDS USD
         * ============================================================
         */

        const cardsUSD = Object.entries(subtotalesMapUSD)
            .filter(([subtotal]) => subtotal !== '')
            .map(([subtotal, importe]) => ({
                subtotal,
                importe,
                importeFinal: formatNumber(importe),
                weightPerc:
                    totalPortafolioUSD !== 0
                        ? (importe / totalPortafolioUSD) * 100
                        : 0
            }));

        setSubtotalesCardsUSD(cardsUSD);


        /*
         * ============================================================
         * %/PORT CUENTA CORRIENTE USD
         * ============================================================
         */

        const weightCCUSD =
            totalPortafolioUSD !== 0
                ? (cuentaCorrienteUSD / totalPortafolioUSD) * 100
                : 0;

        setTotalPortUSD({
            number: weightCCUSD,
            text: formatNumber(weightCCUSD)
        });

    }, [
        prices,
        filterDate,
        entityBalance,
        entityBalanceUSD,
        entityHolding,
        entityHoldingUSD,
        totalSubTotal,
        totalSubTotalUSD
    ]);

    const updatePrice = () => {
        setPrices([]);
        const today = formatLocalDate(new Date());

        if (filterDate === today) {
            pricesVivo();

        } else {
            setPrices([]);
        }

    }

    const exportToExcel = () => {

        const headers = [
            "Especie",
            "Ticker",
            "ISIN",
            "Estado",
            "Cantidad",
            "PC",
            "Costo",
            "PC Mkt",
            "Valor",
            "Var %",
            "Resultado",
            "%/Port"
        ];

        const aoa = [headers];

        /* ==========================================================
           RESUMEN PORTAFOLIO
           ========================================================== */

        const resumenTotal = homeTrade === "ars"
            ? Number(portafolioTotal?.number ?? 0)
            : Number(portafolioTotalUSD?.number ?? 0);
        const resumenDisponible = homeTrade === "ars"
            ? Number(portafolioDisponible?.number ?? 0)
            : Number(portafolioDisponibleUSD?.number ?? 0);
        const resumenALiquidar = homeTrade === "ars"
            ? Number(portafolioALiquidar?.number ?? 0)
            : Number(portafolioALiquidarUSD?.number ?? 0);
        const resumenGarantia = homeTrade === "ars"
            ? Number(portafolioGarantia?.number ?? 0)
            : Number(portafolioGarantiaUSD?.number ?? 0);

        aoa.push(["Portafolio", "", "", "", "", "", "", "", resumenTotal, "", "", ""]);
        aoa.push(["Disponible", "", "", "", "", "", "", "", resumenDisponible, "", "", ""]);

        if (resumenALiquidar !== 0) {
            aoa.push(["A Liquidar", "", "", "", "", "", "", "", resumenALiquidar, "", "", ""]);
        }

        aoa.push(["Garantía", "", "", "", "", "", "", "", resumenGarantia, "", "", ""]);

        /* ==========================================================
           CUENTA CORRIENTE
           ========================================================== */

        if (homeTrade === "ars") {

            entityBalance.forEach(item => {

                item.data.forEach((row, index) => {

                    let cantidad = 0;
                    let valor = 0;

                    switch (item.name) {

                        case "PESOS":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueFx ?? 0);

                            break;


                        case "USD MEP":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueFx ?? 0);

                            break;


                        case "USD CABLE":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueFx ?? 0);

                            break;


                        default:

                            break;
                    }


                    /*
                     * El porcentaje viene directamente del SP.
                     */
                    const portfolio =
                        Number(
                            row.weightPercFx ?? 0
                        ) / 100;


                    aoa.push([

                        index === 0
                            ? item.name
                            : "",

                        "",

                        "",

                        row.status,

                        cantidad,

                        "",

                        "",

                        "",

                        valor,

                        "",

                        "",

                        portfolio

                    ]);

                });

            });


            /*
             * ======================================================
             * SUBTOTAL CUENTA CORRIENTE
             * ======================================================
             */

            aoa.push([

                "Subtotal Cuenta Corriente",

                "",

                "",

                "",

                "",

                "",

                "",

                "",

                Number(
                    totalSubTotal?.number ?? 0
                ),

                "",

                "",

                Number(
                    totalPortArs?.number ?? 0
                ) / 100

            ]);

        } else {

            entityBalanceUSD.forEach(item => {

                item.data.forEach((row, index) => {

                    let cantidad = 0;
                    let valor = 0;

                    switch (item.name) {

                        case "PESOS":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueUsd ?? 0);

                            break;


                        case "USD MEP":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueUsd ?? 0);

                            break;


                        case "USD CABLE":

                            cantidad =
                                Number(row.qty ?? 0);

                            valor =
                                Number(row.valueUsd ?? 0);

                            break;


                        default:

                            break;
                    }


                    /*
                     * El porcentaje viene directamente del SP.
                     */
                    const portfolio =
                        Number(
                            row.weightPercUsd ?? 0
                        ) / 100;


                    aoa.push([

                        index === 0
                            ? item.name
                            : "",

                        "",

                        "",

                        row.status,

                        cantidad,

                        "",

                        "",

                        "",

                        valor,

                        "",

                        "",

                        portfolio

                    ]);

                });

            });


            /*
             * ======================================================
             * SUBTOTAL CUENTA CORRIENTE
             * ======================================================
             */

            aoa.push([

                "Subtotal Cuenta Corriente",

                "",

                "",

                "",

                "",

                "",

                "",

                "",

                Number(
                    totalSubTotalUSD?.number ?? 0
                ),

                "",

                "",

                Number(
                    totalPortUSD?.number ?? 0
                ) / 100

            ]);

        }


        /* ==========================================================
           HOLDINGS / POSICIONES
           ========================================================== */

        const holdings =
            homeTrade === "ars"
                ? entityHolding
                : entityHoldingUSD;


        /*
         * El loadInfo ahora genera grupos separados:
         *
         * 30038__ACCION
         * 30038__OPCION
         *
         * Por lo tanto no hay que volver a identificar
         * HOLDING / OPCION.
         *
         * Cada item ya representa un grupo independiente.
         */

        let subtotal = null;

        let subtotalValor = 0;

        let subtotalCosto = 0;

        let subtotalResultado = 0;

        let subtotalWeightPercFx = 0;

        let subtotalWeightPercUsd = 0;


        holdings.forEach((item) => {

            item.status.forEach((st, g) => {


                /*
                 * ======================================================
                 * CAMBIO DE SUBTOTAL
                 *
                 * Ejemplo:
                 *
                 * 30038__ACCION
                 *        ↓
                 * Subtotal ACCION
                 *
                 * 30038__OPCION
                 *        ↓
                 * Subtotal OPCION
                 *
                 * ======================================================
                 */

                if (
                    subtotal !== null &&
                    item.subtotal !== subtotal
                ) {

                    const portfolioTotal =
                        homeTrade === "ars"
                            ? Number(portafolioTotal?.number ?? 0)
                            : Number(portafolioTotalUSD?.number ?? 0);

                    const portfolio =
                        portfolioTotal !== 0
                            ? Number(subtotalValor ?? 0) / portfolioTotal
                            : 0;


                    aoa.push([

                        `Subtotal ${subtotal}`,

                        "",

                        "",

                        "",

                        "",

                        "",

                        subtotalCosto,

                        "",

                        subtotalValor,

                        "",

                        subtotalResultado,

                        portfolio

                    ]);


                    /*
                     * Reiniciamos acumuladores
                     * para la nueva especie.
                     */

                    subtotalValor = 0;

                    subtotalCosto = 0;

                    subtotalResultado = 0;

                }


                /*
                 * ======================================================
                 * DATOS DE LA POSICIÓN
                 * ======================================================
                 */

                const cantidad =
                    Number(
                        st.qty ?? 0
                    );


                const pc =
                    homeTrade === "ars"

                        ? Number(
                            st.costPriceFx ?? 0
                        )

                        : Number(
                            st.costPriceUsd ?? 0
                        );


                const costo =
                    homeTrade === "ars"

                        ? Number(
                            st.costFx ?? 0
                        )

                        : Number(
                            st.costUsd ?? 0
                        );


                const precio =
                    homeTrade === "ars"

                        ? Number(
                            st.fxPrice ?? 0
                        )

                        : Number(
                            st.fxPriceUsd ?? 0
                        );


                const valor =
                    homeTrade === "ars"

                        ? Number(
                            st.amountFx ?? st.valueFx ?? 0
                        )

                        : Number(
                            st.amountUsd ?? st.valueUsd ?? 0
                        );


                const resultado =
                    homeTrade === "ars"

                        ? Number(
                            st.profitFx ?? 0
                        )

                        : Number(
                            st.profitUsd ?? 0
                        );


                const variacion =
                    homeTrade === "ars"

                        ? Number(
                            st.profitPerc ?? 0
                        ) / 100

                        : Number(
                            st.profitUsdPerc ?? 0
                        ) / 100;


                /*
                 * ======================================================
                 * % PORTAFOLIO
                 *
                 * DIRECTAMENTE DEL SP
                 *
                 * ARS -> weightPercFx
                 * USD -> weightPercUsd
                 * ======================================================
                 */

                const portfolio =
                    homeTrade === "ars"

                        ? Number(
                            st.weightPercFx ?? 0
                        ) / 100

                        : Number(
                            st.weightPercUsd ?? 0
                        ) / 100;


                /*
                 * ======================================================
                 * ACUMULACIÓN DEL SUBTOTAL
                 * ======================================================
                 *
                 * Si existe una fila Total, usamos sólo esa fila.
                 * Si no existe, acumulamos las filas normales.
                 */

                const existeTotal =
                    item.status.some(
                        x =>
                            x.status === "Total"
                    );


                if (existeTotal) {

                    if (
                        st.status === "Total"
                    ) {

                        subtotalValor +=
                            valor;

                        subtotalCosto +=
                            costo;

                        subtotalResultado +=
                            resultado;

                    }

                } else {

                    subtotalValor +=
                        valor;

                    subtotalCosto +=
                        costo;

                    subtotalResultado +=
                        resultado;

                }


                /*
                 * ======================================================
                 * FILA DE LA POSICIÓN
                 * ======================================================
                 *
                 * g === 0:
                 *
                 * mostramos Especie / Ticker / ISIN
                 * sólo en la primera fila del grupo.
                 *
                 * Esto aplica igual para OPCION.
                 */

                aoa.push([

                    g === 0
                        ? item.item
                        : "",

                    item.status[g]?.symbol || (g === 0 ? item.symbol : ""),


                    g === 0
                        ? item.isin
                        : "",

                    st.status,

                    cantidad,

                    pc,

                    costo,

                    precio,

                    valor,

                    variacion,

                    resultado,

                    portfolio

                ]);


                /*
                 * ======================================================
                 * GUARDAMOS EL GRUPO ACTUAL
                 * ======================================================
                 */

                subtotal =
                    item.subtotal;


                /*
                 * Los pesos del subtotal vienen de loadInfo,
                 * que los obtuvo del SUBTOTAL_AC del SP.
                 */

                subtotalWeightPercFx =
                    Number(
                        item.weightPercFx ?? 0
                    );


                subtotalWeightPercUsd =
                    Number(
                        item.weightPercUsd ?? 0
                    );

            });

        });


        /*
         * ==========================================================
         * ÚLTIMO SUBTOTAL
         * ==========================================================
         */

        if (subtotal !== null) {

            const portfolioTotal =
                homeTrade === "ars"
                    ? Number(portafolioTotal?.number ?? 0)
                    : Number(portafolioTotalUSD?.number ?? 0);

            const portfolio =
                portfolioTotal !== 0
                    ? Number(subtotalValor ?? 0) / portfolioTotal
                    : 0;


            aoa.push([

                `Subtotal ${subtotal}`,

                "",

                "",

                "",

                "",

                "",

                subtotalCosto,

                "",

                subtotalValor,

                "",

                subtotalResultado,

                portfolio

            ]);

        }


        /* ==========================================================
           CREAR EXCEL
           ========================================================== */

        const ws =
            XLSX.utils.aoa_to_sheet(
                aoa
            );


        /*
         * ==========================================================
         * FORMATOS
         * ========================================================== */

        Object.keys(ws).forEach(cell => {

            if (
                cell.startsWith("!")
            ) {
                return;
            }


            if (
                typeof ws[cell].v !== "number"
            ) {
                return;
            }


            const col =
                cell.replace(
                    /[0-9]/g,
                    ""
                );


            switch (col) {

                case "E":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "F":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "G":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "H":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "I":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "J":

                    ws[cell].z =
                        "0.00%";

                    break;


                case "K":

                    ws[cell].z =
                        "#,##0.00";

                    break;


                case "L":

                    ws[cell].z =
                        "0.00%";

                    break;


                default:

                    ws[cell].z =
                        "#,##0.00";

                    break;

            }

        });


        /*
         * ==========================================================
         * ANCHO COLUMNAS
         * ========================================================== */

        ws["!cols"] = [

            { wch: 45 }, // Especie

            { wch: 12 }, // Ticker

            { wch: 18 }, // ISIN

            { wch: 18 }, // Estado

            { wch: 14 }, // Cantidad

            { wch: 14 }, // PC

            { wch: 16 }, // Costo

            { wch: 14 }, // PC Mkt

            { wch: 16 }, // Valor

            { wch: 12 }, // Var %

            { wch: 16 }, // Resultado

            { wch: 12 }  // Port %

        ];


        /*
         * ==========================================================
         * ENCABEZADO EN NEGRITA
         * ========================================================== */

        const range =
            XLSX.utils.decode_range(
                ws["!ref"]
            );


        for (
            let c = range.s.c;
            c <= range.e.c;
            c++
        ) {

            const addr =
                XLSX.utils.encode_cell({

                    r: 0,

                    c

                });


            if (!ws[addr]) {
                continue;
            }


            ws[addr].s = {

                font: {

                    bold: true

                }

            };

        }


        /*
         * ==========================================================
         * WORKBOOK
         * ========================================================== */

        const wb =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(

            wb,

            ws,

            "Posición"

        );


        const excelBuffer =
            XLSX.write(

                wb,

                {

                    bookType: "xlsx",

                    type: "array"

                }

            );


        const blob =
            new Blob(

                [excelBuffer],

                {

                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                }

            );


        /*
         * ==========================================================
         * NOMBRE DEL ARCHIVO
         *
         * NO SE MODIFICA.
         * ==========================================================
         */

        const moneda =
            homeTrade.toUpperCase();


        const fecha =
            filterDate

                ? `${filterDate.split("-")[2]}${filterDate.split("-")[1]}${filterDate.split("-")[0].substring(2, 4)}`

                : "";


        const nombre = [

            "Posicion",

            moneda,

            fecha,

            filterComitente?.id,

            filterManager?.id

        ]
            .filter(Boolean)
            .join("_");


        saveAs(
            blob,
            `${nombre}.xlsx`
        );

    };



    return (

        <>
            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
                <div style={{ overflowX: 'hidden' }}>
                    <MenuApp />
                    <Box border={1} marginTop="4rem" borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <Box display="flex" alignItems="center" gap={1}>


                            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_BUTTON_THEME}>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // columna en mobile, fila en grande
                                        gap: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 1
                                        }}
                                    >
                                        <BusinessCenterOutlined fontSize="large" />

                                        <Button
                                            color="primary"
                                            variant={homeTrade === 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('ars')}
                                        >
                                            ARS
                                        </Button>

                                        <Button
                                            color="primary"
                                            variant={homeTrade !== 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('usd')}
                                        >
                                            MEP
                                        </Button>

                                        <DateComponent
                                            disabled={false}
                                            id="filterDate"
                                            name="Liquidación"
                                            value={filterDate}
                                            onChange={(newDate) => handleFieldChange({ target: { value: newDate } })}
                                            help={null}
                                            mode="c"
                                            design={null}
                                            view={null}
                                        />

                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={updatePrice}
                                            style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                        >
                                            <RefreshIcon />
                                        </Button>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" }, // apila en mobile, fila en grande
                                            gap: 1,
                                            flex: 1
                                        }}
                                    >
                                        {viewComitente && (
                                            <>
                                                <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                                    {loadSubtotalesCards && (
                                                        <Autocomplete
                                                            options={optionsComitentes}
                                                            getOptionLabel={(option) => option.label}
                                                            value={filterComitente}
                                                            onChange={handleChange}
                                                            inputValue={inputValue}
                                                            onInputChange={handleInputChange}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            disabled={(user.data.managerId && user.data.tradeAccountId) ? true : false}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Cuenta Comitente"
                                                                    variant="outlined"
                                                                    sx={{
                                                                        '& .MuiInputBase-root': {
                                                                            height: 32,
                                                                            minHeight: 32,
                                                                            paddingRight: '8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '0 8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputLabel-root': {
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            top: '-4px',
                                                                        },

                                                                        '& .MuiInputLabel-shrink': {
                                                                            transform: 'translate(14px, -3px) scale(0.58)',
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 0,
                                                                        },
                                                                        '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 2500,
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                            fullWidth
                                                            slotProps={{
                                                                popper: {
                                                                    sx: {
                                                                        '& .MuiAutocomplete-option': {
                                                                            fontSize: 'inherit'
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </>
                                        )}

                                        <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                            {loadSubtotalesCards && (
                                                <Autocomplete
                                                    options={optionsManager}
                                                    getOptionLabel={(option) => option.label}
                                                    value={filterManager}
                                                    onChange={handleChangeManager}
                                                    inputValue={inputValueManager}
                                                    onInputChange={handleInputChangeManager}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    disabled={(user.data.managerId && !user.data.tradeAccountId) || !viewManager ? true : false}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Agente Productor"
                                                            variant="outlined"
                                                            sx={{
                                                                '& .MuiInputBase-root': {
                                                                    height: 32,
                                                                    minHeight: 32,
                                                                    paddingRight: '8px',
                                                                    fontSize: "inherit",
                                                                    fontWeight: '600',
                                                                    lineHeight: "inherit"
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: '0 8px',
                                                                    fontSize: "inherit",
                                                                    fontWeight: '600',
                                                                    lineHeight: "inherit"
                                                                },
                                                                '& .MuiInputLabel-root': {
                                                                    fontSize: "inherit",
                                                                    fontWeight: '600',
                                                                    top: '-4px',
                                                                },
                                                                '& .MuiInputLabel-shrink': {
                                                                    transform: 'translate(14px, -3px) scale(0.58)',
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline legend': {
                                                                    maxWidth: 0,
                                                                },
                                                                '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                    maxWidth: 2500,
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                    fullWidth
                                                />
                                            )}
                                        </Box>


                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            gap: 1,
                                            flex: 1
                                        }}
                                    >


                                        {loadSubtotalesCards &&
                                            //(subtotalesCardsUSD.length > 0 || subtotalesCards.length > 0) && (
                                            (

                                                <>
                                                    <BlobProvider
                                                        document={
                                                            <VistaPdfExport
                                                                homeTrade={homeTrade}
                                                                portafolioTotal={portafolioTotal}
                                                                portafolioDisponible={portafolioDisponible}
                                                                portafolioGarantia={portafolioGarantia}
                                                                portafolioALiquidar={portafolioALiquidar}
                                                                portafolioTotalUSD={portafolioTotalUSD}
                                                                portafolioDisponibleUSD={portafolioDisponibleUSD}
                                                                portafolioGarantiaUSD={portafolioGarantiaUSD}
                                                                portafolioALiquidarUSD={portafolioALiquidarUSD}
                                                                entityBalance={entityBalance}
                                                                entityBalanceUSD={entityBalanceUSD}
                                                                entityHolding={entityHolding}
                                                                entityHoldingUSD={entityHoldingUSD}
                                                                subtotalesCards={subtotalesCards}
                                                                subtotalesCardsUSD={subtotalesCardsUSD}
                                                                totalSubTotal={totalSubTotal}
                                                                totalSubTotalUSD={totalSubTotalUSD}
                                                                backgroundColor={backgroundColor}
                                                                DoughnutComponent={Doughnut}
                                                                tipoCambio={tipoCambio}
                                                                tipoCambioCcl={tipoCambioCcl}
                                                                amountCtaCte={amountCtaCte}
                                                                amountCtaCteUSD={amountCtaCteUSD}
                                                                setViewEntityBalance={setViewEntityBalance}
                                                                setViewEntityBalanceUSD={setViewEntityBalanceUSD}
                                                                setViewEntitHolding={setViewEntitHolding}
                                                                setViewEntitHoldingMEP={setViewEntitHoldingMEP}
                                                                filterManager={filterManager}
                                                                viewManager={viewManager}
                                                                viewComitente={viewComitente}
                                                                filterComitente={filterComitente}
                                                                filterDate={filterDate}
                                                                weightPercFxCC={totalPortArs?.number ?? 0}
                                                                weightPercUsdCC={totalPortUSD?.number ?? 0}
                                                            />
                                                        }
                                                    >
                                                        {({ blob, loading }) => {

                                                            if (loading) {
                                                                return <span></span>;
                                                            }

                                                            return (
                                                                <PictureAsPdfIcon
                                                                    fontSize="large"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={async () => {

                                                                        try {

                                                                            const formData = new FormData();
                                                                            formData.append("file", blob, "position.pdf");

                                                                            const response = await informationService.pdfprotect(formData);

                                                                            const protectedBlob = response.data;

                                                                            const url = window.URL.createObjectURL(protectedBlob);

                                                                            const a = document.createElement("a");

                                                                            const moneda = homeTrade?.toUpperCase();
                                                                            const fecha = filterDate
                                                                                ? `${filterDate.split('-')[2]}${filterDate.split('-')[1]}${filterDate.split('-')[0].substring(2, 4)}`
                                                                                : null;

                                                                            const comitente = filterComitente?.id;

                                                                            const agenteProductor = filterManager?.id;

                                                                            const partesNombre = [
                                                                                "Posición",
                                                                                moneda,
                                                                                fecha,
                                                                                comitente,
                                                                                agenteProductor
                                                                            ].filter(value => value !== null && value !== undefined && value !== "");

                                                                            a.href = url;
                                                                            a.download = `${partesNombre.join("_")}.pdf`;

                                                                            document.body.appendChild(a);

                                                                            a.click();

                                                                            a.remove();

                                                                            window.URL.revokeObjectURL(url);

                                                                        } catch (e) {
                                                                            console.error(e);
                                                                        }

                                                                    }}
                                                                />
                                                            );
                                                        }}
                                                    </BlobProvider>
                                                    <TableChartIcon
                                                        fontSize="large"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={exportToExcel}
                                                    />
                                                </>
                                            )}
                                    </Box>
                                </Box>
                            </ThemeProvider>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' }, // responsive: en mobile apila
                                justifyContent: 'space-between',             // separa gráfico y tabla
                                alignItems: 'flex-start',                    // alinea arriba
                                gap: 4,                                       // espacio entre ambos
                                width: '100%',
                                marginTop: '20px'
                            }}
                        >

                            <Box
                                sx={{
                                    width: { xs: '100%', md: 600 },
                                    mt: { xs: 4, md: 0 },
                                    ml: { xs: 0, md: 'auto' },
                                }}
                            >
                                {loadSubtotalesCards && (
                                    <TableContainer component={Paper} sx={{ maxHeight: 400, overflowX: 'auto', overflowY: 'auto', flex: 1, width: '100%' }}>
                                        <Table size="small">
                                            <TableBody>
                                                <TableRow sx={getRowStyle(false, 0)}>
                                                    <TableCell> <Box display="flex" alignItems="center" gap={1}>
                                                        <WorkOutline />
                                                        Portafolio
                                                    </Box></TableCell>
                                                    <TableCell></TableCell>
                                                    {homeTrade === 'ars' && (
                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioTotal.number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>$</span>
                                                                <span>{portafolioTotal.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                    {homeTrade === 'usd' && (
                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioTotalUSD.number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>USD</span>
                                                                <span>{portafolioTotalUSD.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                </TableRow>

                                                <TableRow sx={getRowStyle(false, 1)}>
                                                    <TableCell><Box display="flex" alignItems="center" gap={1}><LockOpen />Disponible </Box></TableCell>
                                                    <TableCell></TableCell>
                                                    {homeTrade === 'ars' && (
                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioDisponible.number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>$</span>
                                                                <span>{portafolioDisponible.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                    {homeTrade === 'usd' && (
                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioDisponibleUSD.number) < 0 ? "red" : "black" }} align="right">
                                                            <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                <span>USD</span>
                                                                <span>{portafolioDisponibleUSD.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                </TableRow>

                                                {homeTrade === 'ars' && portafolioALiquidar.number !== 0 && (
                                                    <TableRow sx={getRowStyle(false, 1)}>
                                                        <TableCell>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <WalletOutlined />
                                                                A Liquidar
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                            style={{
                                                                fontVariantNumeric: 'tabular-nums',
                                                                letterSpacing: "0.01rem",
                                                                color: Number(portafolioALiquidar.number) < 0 ? "red" : "black"
                                                            }}
                                                            align="right"
                                                        >
                                                            <div style={{
                                                                fontVariantNumeric: 'tabular-nums',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                width: '100%'
                                                            }}>
                                                                <span>$</span>
                                                                <span>{portafolioALiquidar.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {homeTrade === 'usd' && portafolioALiquidarUSD.number !== 0 && (
                                                    <TableRow sx={getRowStyle(false, 1)}>
                                                        <TableCell>
                                                            <Box display="flex" alignItems="center" gap={1}>
                                                                <WalletOutlined />
                                                                A Liquidar
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                            style={{
                                                                fontVariantNumeric: 'tabular-nums',
                                                                letterSpacing: "0.01rem",
                                                                color: Number(portafolioALiquidarUSD.number) < 0 ? "red" : "black"
                                                            }}
                                                            align="right"
                                                        >
                                                            <div style={{
                                                                fontVariantNumeric: 'tabular-nums',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                width: '100%'
                                                            }}>
                                                                <span>USD</span>
                                                                <span>{portafolioALiquidarUSD.text}</span>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {((homeTrade === 'ars' && Number(portafolioGarantia?.number ?? 0) !== 0) ||
                                                    (homeTrade === 'usd' && Number(portafolioGarantiaUSD?.number ?? 0) !== 0)) && (
                                                        <TableRow sx={getRowStyle(false, 2)}>
                                                            <TableCell><Box display="flex" alignItems="center" gap={1}><LockOutline />Garantía</Box></TableCell>
                                                            <TableCell></TableCell>
                                                            {homeTrade === 'ars' && (
                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioGarantia.number) < 0 ? "red" : "black" }} align="right">
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        <span>$</span>
                                                                        <span>{portafolioGarantia.text}</span>
                                                                    </div>
                                                                </TableCell>
                                                            )}
                                                            {homeTrade === 'usd' && (
                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(portafolioGarantiaUSD.number) < 0 ? "red" : "black" }} align="right">
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        <span>USD</span>
                                                                        <span>{portafolioGarantiaUSD.text}</span>
                                                                    </div>
                                                                </TableCell>
                                                            )}
                                                        </TableRow>
                                                    )}

                                                {homeTrade === 'ars' && (
                                                    entityBalance
                                                        .filter(item => item.data?.some(row => row.status !== 'Garantía'))
                                                        .map((item, idx) => {
                                                            return <TableRow sx={getRowStyle(false, idx + 1)}>
                                                                <TableCell><Box display="flex" alignItems="center" gap={1}>{item.name === 'PESOS' ? <WalletOutlined /> : item.name === 'USD MEP' ? <LocalAtmOutlined /> : <Sensors />}{item.name}</Box></TableCell>
                                                                <TableCell>{item.name === 'USD MEP' ? `TC:${tipoCambio}` : item.name === 'USD CABLE' ? `TC:${tipoCambioCcl}` : ''}</TableCell>
                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(amountCtaCte(item).number) < 0 ? "red" : "black" }} align="right">
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        <span>$</span>
                                                                        <span>{amountCtaCte(item).text}</span>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        })
                                                )}
                                                {homeTrade === 'usd' && (
                                                    entityBalanceUSD
                                                        .filter(item => item.data?.some(row => row.status !== 'Garantía'))
                                                        .map((item, idx) => {
                                                            return <TableRow sx={getRowStyle(false, idx + 1)}>
                                                                <TableCell><Box display="flex" alignItems="center" gap={1}>{item.name === 'PESOS' ? <WalletOutlined /> : item.name === 'USD MEP' ? <LocalAtmOutlined /> : <Sensors />}{item.name}</Box></TableCell>
                                                                <TableCell>{item.name === 'USD MEP' ? `TC:${tipoCambio}` : item.name === 'USD CABLE' ? `TC:${tipoCambioCcl}` : ''}</TableCell>
                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(amountCtaCteUSD(item).number) < 0 ? "red" : "black" }} align="right">
                                                                    <div style={{ fontVariantNumeric: 'tabular-nums', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                        <span>USD</span>
                                                                        <span>{amountCtaCteUSD(item).text}</span>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        })
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                                {!loadSubtotalesCards && (
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <CircularProgress size={60} />
                                    </div>
                                )}
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' }, // Responsive
                                    gap: 2,
                                    flex: 1,
                                }}
                            >

                                {homeTrade === 'ars' && Number(portafolioTotal?.number || 0) !== 0 && (
                                    <Box sx={{ width: 250, height: 250, mx: 'auto' }}>
                                        {loadSubtotalesCards && (
                                            <Doughnut
                                                subtotalesCards={[
                                                    ...(Number(totalSubTotal?.number || 0) !== 0
                                                        ? [{
                                                            subtotal: 'Cuenta Corriente',
                                                            importe: Number(totalSubTotal.number),
                                                            importeFinal: totalSubTotal.text,
                                                            weightPerc: Number(totalPortArs?.number || 0)
                                                        }]
                                                        : []),
                                                    ...subtotalesCards
                                                ]}
                                                tot={portafolioTotal.text}
                                            />
                                        )}

                                        {!loadSubtotalesCards && (
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <CircularProgress size={60} />
                                            </div>
                                        )}
                                    </Box>
                                )}

                                {homeTrade === 'usd' && Number(portafolioTotalUSD?.number || 0) !== 0 && (
                                    <Box sx={{ width: 250, height: 250, mx: 'auto' }}>
                                        {loadSubtotalesCards && (
                                            <Doughnut
                                                subtotalesCards={[
                                                    ...(Number(totalSubTotalUSD?.number || 0) !== 0
                                                        ? [{
                                                            subtotal: 'Cuenta Corriente',
                                                            importe: Number(totalSubTotalUSD.number),
                                                            importeFinal: totalSubTotalUSD.text,
                                                            weightPerc: Number(totalPortUSD?.number || 0)
                                                        }]
                                                        : []),
                                                    ...subtotalesCardsUSD
                                                ]}
                                                tot={portafolioTotalUSD.text}
                                            />
                                        )}

                                        {!loadSubtotalesCards && (
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <CircularProgress size={60} />
                                            </div>
                                        )}
                                    </Box>
                                )}

                                <Grid
                                    container
                                    spacing={2}
                                    sx={{
                                        flex: 1,
                                        alignContent: 'flex-start',
                                    }}
                                >
                                    {homeTrade === 'ars' && (

                                        [
                                            ...(loadSubtotalesCards &&
                                                Number(totalSubTotal?.number || 0) !== 0
                                                ? [{
                                                    subtotal: 'Cuenta Corriente',
                                                    importe: Number(totalSubTotal.number),
                                                    importeFinal: totalSubTotal.text,
                                                    weightPerc: Number(totalPortArs?.number || 0)
                                                }]
                                                : []),
                                            ...subtotalesCards
                                        ].map((card, index) => (
                                            <Grid
                                                item
                                                key={`ars-${card.subtotal}-${index}`}
                                                xs={12}
                                                sm={6}
                                                lg={4}
                                            >
                                                <Card
                                                    sx={{
                                                        borderTop:
                                                            '6px solid ' +
                                                            backgroundColor[index],
                                                        borderRadius: 2,
                                                        boxShadow: 2,
                                                    }}
                                                >
                                                    <CardContent>

                                                        <Typography
                                                            color="black"
                                                            variant="body3"
                                                            gutterBottom
                                                        >
                                                            {card.subtotal}
                                                        </Typography>

                                                        <Typography
                                                            variant="body3"
                                                            sx={{
                                                                whiteSpace: 'pre-line',
                                                                fontWeight: 'bold'
                                                            }}
                                                            color={
                                                                Number(card.importe) < 0
                                                                    ? 'red'
                                                                    : 'black'
                                                            }
                                                        >
                                                            {`\n${card.importeFinal}`}
                                                        </Typography>

                                                        <Typography
                                                            variant="body3"
                                                            sx={{
                                                                whiteSpace: 'pre-line',
                                                            }}
                                                            color={
                                                                Number(card.importe) < 0
                                                                    ? 'red'
                                                                    : 'black'
                                                            }
                                                        >
                                                            {`\n${(
                                                                (Number(card.importe) /
                                                                    totalImporteFinal) *
                                                                100
                                                            ).toFixed(2)}%`}
                                                        </Typography>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))

                                    )}

                                    {homeTrade === 'usd' && (

                                        [
                                            ...(loadSubtotalesCards &&
                                                Number(totalSubTotalUSD?.number || 0) !== 0
                                                ? [{
                                                    subtotal: 'Cuenta Corriente',
                                                    importe: Number(totalSubTotalUSD.number),
                                                    importeFinal: totalSubTotalUSD.text,
                                                    weightPerc: Number(totalPortUSD?.number || 0)
                                                }]
                                                : []),
                                            ...subtotalesCardsUSD
                                        ].map((card, index) => (
                                            <Grid
                                                item
                                                key={`usd-${card.subtotal}-${index}`}
                                                xs={12}
                                                sm={6}
                                                lg={4}
                                            >
                                                <Card
                                                    sx={{
                                                        borderTop:
                                                            '6px solid ' +
                                                            backgroundColor[index],
                                                        borderRadius: 2,
                                                        boxShadow: 2,
                                                    }}
                                                >
                                                    <CardContent>

                                                        <Typography
                                                            color="black"
                                                            variant="body3"
                                                            gutterBottom
                                                        >
                                                            {card.subtotal}
                                                        </Typography>

                                                        <Typography
                                                            variant="body3"
                                                            sx={{
                                                                whiteSpace: 'pre-line',
                                                                fontWeight: 'bold'
                                                            }}
                                                            color={
                                                                Number(card.importe) < 0
                                                                    ? 'red'
                                                                    : 'black'
                                                            }
                                                        >
                                                            {`\n${card.importeFinal}`}
                                                        </Typography>

                                                        <Typography
                                                            variant="body3"
                                                            sx={{
                                                                whiteSpace: 'pre-line',
                                                            }}
                                                            color={
                                                                Number(card.importe) < 0
                                                                    ? 'red'
                                                                    : 'black'
                                                            }
                                                        >
                                                            {`\n${(
                                                                (Number(card.importe) /
                                                                    totalImporteFinalUSD) *
                                                                100
                                                            ).toFixed(2)}%`}
                                                        </Typography>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))

                                    )}
                                </Grid>
                            </Box>
                        </Box>
                    </Box>

                    <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <TableContainer component={Paper} sx={{
                            overflowX: 'auto',
                            overflowY: 'auto'
                        }}/*sx={{ maxHeight: '500px', overflowY: 'auto' }}*/>
                            <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                        <TableCell
                                            sx={{
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 6,
                                                backgroundColor: 'rgb(50 59 152)',
                                                color: 'white',
                                                minWidth: 180
                                            }}
                                        >
                                            Especie
                                        </TableCell>
                                        <TableCell style={{ color: 'white' }}>Ticker</TableCell>
                                        <TableCell style={{ color: 'white' }}>ISIN</TableCell>
                                        <TableCell style={{ color: 'white' }}>Estado</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Cantidad</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>PC</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Costo</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>PC Mkt</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Valor</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Var %</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Resultado</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>%/Port</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {homeTrade === 'ars' && (
                                        entityBalance.map((item, index) => {
                                            return setViewEntityBalance(item, 'ui');
                                        })
                                    )}
                                    {homeTrade === 'usd' && (
                                        entityBalanceUSD.map((item, index) => {
                                            return setViewEntityBalanceUSD(item, 'ui');
                                        })
                                    )}
                                    <TableRow sx={getRowStyle(true, 500)}>
                                        <TableCell sx={{
                                            position: 'sticky',
                                            left: 0,
                                            //backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            zIndex: 3,
                                            minWidth: 180
                                        }} style={{ fontWeight: 'bold' }}>Subtotal Cuenta Corriente</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        {homeTrade === 'ars' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalSubTotal.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotal.text}</TableCell>
                                        )}
                                        {homeTrade === 'usd' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalSubTotalUSD.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotalUSD.text}</TableCell>
                                        )}
                                        <TableCell></TableCell>
                                        {/*{homeTrade === 'ars' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalSubTotal.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotal.text}</TableCell>
                                        )}
                                        {homeTrade === 'usd' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalSubTotalUSD.number) < 0 ? "red" : "black" }} align='right'>{totalSubTotalUSD.text}</TableCell>
                                        )}*/}
                                        <TableCell></TableCell>
                                        {homeTrade === 'ars' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalPortArs.number) < 0 ? "red" : "black" }} align='right'>{totalPortArs.text}%</TableCell>
                                        )}
                                        {homeTrade === 'usd' && (
                                            <TableCell style={{ fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(totalPortUSD.number) < 0 ? "red" : "black" }} align='right'>{totalPortUSD.text}%</TableCell>
                                        )}
                                    </TableRow>
                                    {homeTrade === 'ars' && (
                                        setViewEntitHolding(entityHolding, 'ui')
                                    )}
                                    {homeTrade === 'usd' && (
                                        setViewEntitHoldingMEP(entityHoldingUSD, 'ui')
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box padding={1}>
                        <p style={{ fontSize: '10px', margin: '2px 0' }}>
                            Los saldos e información contenidos en el presente revisten carácter informativo y se encuentran sujetos a verificación.</p>
                        <p style={{ fontSize: '10px', margin: '2px 0' }}>
                            Salvo Error u Omisión (S.E.U.O.).</p>
                        <p style={{ fontSize: '10px', margin: '2px 0' }}>
                            La documentación respaldatoria de las operaciones se encuentra a disposición del cliente conforme la normativa vigente de la CNV (Título VII, Capítulo II T.O.).</p>
                    </Box>

                </div >
                <FooterOperaciones />
            </ThemeProvider >


        </>
    )
}

class PositionErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            error: null,
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ERROR EN POSITION:", error);
        console.error("POSITION COMPONENT STACK:", errorInfo?.componentStack);
    }

    handleRetry = () => {
        window.location.reload();
    };

    getErrorLocation = (error) => {
        const stack = error?.stack || "";

        // Busca ubicaciones del tipo: Position.jsx:2456:18 o main.js:1:483920
        const matches = [
            ...stack.matchAll(/(?:at\s+.*?\s+\()?((?:https?:\/\/[^\s)]+\/)?[^\s():]+\.(?:jsx?|tsx?)):(\d+):(\d+)\)?/g),
            ...stack.matchAll(/(?:at\s+.*?\s+\()?([^\s():]+\.js):(\d+):(\d+)\)?/g),
        ];

        if (matches.length > 0) {
            const match = matches[0];
            return {
                file: match[1],
                line: match[2],
                column: match[3],
            };
        }

        // Fallback para stacks que no incluyen extensión de archivo de forma estándar.
        const fallback = stack.match(/([^\s():]+):(\d+):(\d+)/);

        if (fallback) {
            return {
                file: fallback[1],
                line: fallback[2],
                column: fallback[3],
            };
        }

        return {
            file: "No disponible",
            line: "No disponible",
            column: "No disponible",
        };
    };

    render() {
        if (this.state.hasError) {
            const error = this.state.error;
            const errorMessage =
                error?.message ||
                error?.toString?.() ||
                "Error desconocido";
            const errorLocation = this.getErrorLocation(error);
            const stack = error?.stack || "No disponible";

            return (
                <div
                    style={{
                        width: "100%",
                        minHeight: "70vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "30px",
                        boxSizing: "border-box",
                        backgroundColor: "#fff",
                        textAlign: "center",
                    }}
                >
                    <div
                        style={{
                            width: "min(900px, 95%)",
                            padding: "30px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
                            backgroundColor: "#fff",
                            boxSizing: "border-box",
                        }}
                    >
                        <h2 style={{ marginTop: 0, color: "#333" }}>
                            Ocurrió un error inesperado
                        </h2>

                        <p style={{ color: "#555", fontSize: "16px" }}>
                            No se pudo cargar la pantalla de Posición.
                        </p>

                        <p style={{ color: "#555", fontSize: "16px" }}>
                            Por favor, tome una captura de esta pantalla y
                            envíela a Soporte para que podamos revisar el problema.
                        </p>

                        <div
                            style={{
                                marginTop: "20px",
                                padding: "15px",
                                textAlign: "left",
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                                overflowWrap: "anywhere",
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "bold",
                                    marginBottom: "8px",
                                    color: "#333",
                                }}
                            >
                                Detalle del error:
                            </div>

                            <div
                                style={{
                                    fontFamily: "monospace",
                                    fontSize: "13px",
                                    color: "#b00020",
                                    whiteSpace: "pre-wrap",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {errorMessage}
                            </div>

                            <div
                                style={{
                                    marginTop: "15px",
                                    fontFamily: "monospace",
                                    fontSize: "13px",
                                    color: "#333",
                                }}
                            >
                                <div><strong>Archivo:</strong> {errorLocation.file}</div>
                                <div><strong>Línea:</strong> {errorLocation.line}</div>
                                <div><strong>Columna:</strong> {errorLocation.column}</div>
                            </div>

                            <div
                                style={{
                                    marginTop: "15px",
                                    fontWeight: "bold",
                                    color: "#333",
                                }}
                            >
                                Información técnica:
                            </div>

                            <pre
                                style={{
                                    margin: "8px 0 0",
                                    maxHeight: "220px",
                                    overflow: "auto",
                                    fontFamily: "monospace",
                                    fontSize: "11px",
                                    color: "#555",
                                    whiteSpace: "pre-wrap",
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {stack}
                            </pre>
                        </div>

                        <button
                            type="button"
                            onClick={this.handleRetry}
                            style={{
                                marginTop: "25px",
                                padding: "10px 24px",
                                border: "none",
                                borderRadius: "4px",
                                backgroundColor: "#1E3A8A",
                                color: "white",
                                fontSize: "15px",
                                cursor: "pointer",
                            }}
                        >
                            Reintentar
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

const PositionWithErrorBoundary = () => (
    <PositionErrorBoundary>
        <Position />
    </PositionErrorBoundary>
);

export default PositionWithErrorBoundary